import mock from '@/@fake-db/mock'
/* eslint-disable global-require */
const data = {
  tableBasic: [
    {
      id: 1,
      avatar: require('@/assets/images/avatars/10-small.png'),
      fullName: "Korrie O'Crevy",
      email: 'kocrevy0@thetimes.co.uk',
      startDate: '09/23/2016',
      salary: '$23896.35',
      status: 'Professional',
    },
    {
      id: 2,
      avatar: require('@/assets/images/avatars/1-small.png'),
      fullName: 'Bailie Coulman',
      email: 'bcoulman1@yolasite.com',
      startDate: '05/20/2018',
      salary: '$13633.69',
      status: 'Resigned',
    },
    {
      id: 3,
      avatar: require('@/assets/images/avatars/9-small.png'),
      fullName: 'Stella Ganderton',
      email: 'sganderton2@tuttocitta.it',
      startDate: '03/24/2018',
      salary: '$13076.28',
      status: 'Professional',
    },
    {
      id: 4,
      avatar: require('@/assets/images/avatars/3-small.png'),
      fullName: 'Dorolice Crossman',
      email: 'dcrossman3@google.co.jp',
      startDate: '12/03/2017',
      salary: '$12336.17',
      status: 'Applied',
    },
    {
      id: 5,
      avatar: require('@/assets/images/avatars/4-small.png'),
      fullName: 'Harmonia Nisius',
      email: 'hnisius4@gnu.org',
      startDate: '08/25/2017',
      salary: '$10909.52',
      status: 'Professional',
    },
    {
      id: 6,
      avatar: require('@/assets/images/avatars/5-small.png'),
      fullName: 'Genevra Honeywood',
      email: 'ghoneywood5@narod.ru',
      startDate: '06/01/2017',
      salary: '$17803.8',
      status: 'Current',
    },
    {
      id: 7,
      avatar: require('@/assets/images/avatars/7-small.png'),
      fullName: 'Eileen Diehn',
      email: 'ediehn6@163.com',
      startDate: '10/15/2017',
      salary: '$18991.67',
      status: 'Professional',
    },
    {
      id: 8,
      avatar: require('@/assets/images/avatars/9-small.png'),
      fullName: 'Richardo Aldren',
      email: 'raldren7@mtv.com',
      startDate: '11/05/2016',
      salary: '$19230.13',
      status: 'Rejected',
    },
    {
      id: 9,
      avatar: require('@/assets/images/avatars/2-small.png'),
      fullName: 'Allyson Moakler',
      email: 'amoakler8@shareasale.com',
      startDate: '12/29/2018',
      salary: '$11677.32',
      status: 'Applied',
    },
    {
      id: 10,
      avatar: require('@/assets/images/avatars/6-small.png'),
      fullName: 'Merline Penhalewick',
      email: 'mpenhalewick9@php.net',
      startDate: '04/19/2019',
      salary: '$15939.52',
      status: 'Professional',
    },
  ],

  tableRowGrp: [
    {
      mode: 'span',
      label: 'Accountant',
      html: false,
      children: [
        {
          id: 1,
          avatar: require('@/assets/images/avatars/10-small.png'),
          fullName: "Korrie O'Crevy",
          email: 'kocrevy0@thetimes.co.uk',
          startDate: '09/23/2016',
          salary: '$23896.35',
          experience: '1 Year',
          status: 'Professional',
        },
      ],
    },
    {
      mode: 'span',
      label: 'Actuary',
      children: [
        {
          id: 2,
          avatar: require('@/assets/images/avatars/1-small.png'),
          fullName: 'Bailie Coulman',
          email: 'bcoulman1@yolasite.com',
          startDate: '05/20/2018',
          salary: '$13633.69',
          status: 'Current',
        },
      ],
    },
    {
      mode: 'span',
      label: 'Administrative Assistan',
      children: [
        {
          id: 3,
          avatar: require('@/assets/images/avatars/9-small.png'),
          fullName: 'Stella Ganderton',
          email: 'sganderton2@tuttocitta.it',
          startDate: '03/24/2018',
          salary: '$13076.28',
          status: 'Applied',
        },
        {
          id: 4,
          avatar: require('@/assets/images/avatars/3-small.png'),
          fullName: 'Dorolice Crossman',
          email: 'dcrossman3@google.co.jp',
          startDate: '12/03/2017',
          salary: '$12336.17',
          status: 'Professional',
        },
        {
          id: 5,
          avatar: require('@/assets/images/avatars/4-small.png'),
          fullName: 'Harmonia Nisius',
          email: 'hnisius4@gnu.org',
          startDate: '08/25/2017',
          salary: '$10909.52',
          status: 'Resigned',
        },
      ],
    },
    {
      mode: 'span',
      label: 'Analog Circuit Design manager',
      children: [
        {
          id: 6,
          avatar: require('@/assets/images/avatars/5-small.png'),
          fullName: 'Genevra Honeywood',
          email: 'ghoneywood5@narod.ru',
          startDate: '06/01/2017',
          salary: '$17803.8',
          experience: '1 Year',
          status: 'Current',
        },
        {
          id: 7,
          avatar: require('@/assets/images/avatars/7-small.png'),
          fullName: 'Eileen Diehn',
          email: 'ediehn6@163.com',
          startDate: '10/15/2017',
          salary: '$18991.67',
          status: 'Professional',
        },
      ],
    },
    {
      mode: 'span',
      label: 'Analyst Programmer',
      children: [
        {
          id: 8,
          avatar: require('@/assets/images/avatars/9-small.png'),
          fullName: 'Richardo Aldren',
          email: 'raldren7@mtv.com',
          startDate: '11/05/2016',
          salary: '$19230.13',
          status: 'Rejected',
        },
        {
          id: 9,
          avatar: require('@/assets/images/avatars/2-small.png'),
          fullName: 'Allyson Moakler',
          email: 'amoakler8@shareasale.com',
          startDate: '12/29/2018',
          salary: '$11677.32',
          status: 'Applied',
        },
        {
          id: 10,
          avatar: require('@/assets/images/avatars/6-small.png'),
          fullName: 'Merline Penhalewick',
          email: 'mpenhalewick9@php.net',
          startDate: '04/19/2019',
          salary: '$15939.52',
          status: 'Professional',
        },
      ],
    },
  ],

  tableAdvancedSearch: [
    {
      id: 1,
      avatar: require('@/assets/images/avatars/10-small.png'),
      fullName: "Korrie O'Crevy",
      post: 'Nuclear Power Engineer',
      email: 'kocrevy0@thetimes.co.uk',
      city: 'Krasnosilka',
      startDate: '09/23/2016',
      salary: '$23896.35',
    },
    {
      id: 2,
      avatar: require('@/assets/images/avatars/1-small.png'),
      fullName: 'Bailie Coulman',
      post: 'VP Quality Control',
      email: 'bcoulman1@yolasite.com',
      city: 'Hinigaran',
      startDate: '05/20/2018',
      salary: '$13633.69',
    },
    {
      id: 3,
      avatar: require('@/assets/images/avatars/9-small.png'),
      fullName: 'Stella Ganderton',
      post: 'Operator',
      email: 'sganderton2@tuttocitta.it',
      city: 'Golcowa',
      startDate: '03/24/2018',
      salary: '$13076.28',
    },
    {
      id: 4,
      avatar: require('@/assets/images/avatars/3-small.png'),
      fullName: 'Dorolice Crossman',
      post: 'Cost Accountant',
      email: 'dcrossman3@google.co.jp',
      city: 'Paquera',
      startDate: '12/03/2017',
      salary: '$12336.17',
    },
    {
      id: 5,
      avatar: require('@/assets/images/avatars/4-small.png'),
      fullName: 'Harmonia Nisius',
      post: 'Senior Cost Accountant',
      email: 'hnisius4@gnu.org',
      city: 'Lucan',
      startDate: '08/25/2017',
      salary: '$10909.52',
    },
    {
      id: 6,
      avatar: require('@/assets/images/avatars/5-small.png'),
      fullName: 'Genevra Honeywood',
      post: 'Geologist',
      email: 'ghoneywood5@narod.ru',
      city: 'Maofan',
      startDate: '06/01/2017',
      salary: '$17803.8',
    },
    {
      id: 7,
      avatar: require('@/assets/images/avatars/7-small.png'),
      fullName: 'Eileen Diehn',
      post: 'Environmental Specialist',
      email: 'ediehn6@163.com',
      city: 'Lampuyang',
      startDate: '10/15/2017',
      salary: '$18991.67',
    },
    {
      id: 8,
      avatar: require('@/assets/images/avatars/9-small.png'),
      fullName: 'Richardo Aldren',
      post: 'Senior Sales Associate',
      email: 'raldren7@mtv.com',
      city: 'Skoghall',
      startDate: '11/05/2016',
      salary: '$19230.13',
    },
    {
      id: 9,
      avatar: require('@/assets/images/avatars/2-small.png'),
      fullName: 'Allyson Moakler',
      post: 'Safety Technician',
      email: 'amoakler8@shareasale.com',
      city: 'Mogilany',
      startDate: '12/29/2018',
      salary: '$11677.32',
    },
    {
      id: 10,
      avatar: require('@/assets/images/avatars/6-small.png'),
      fullName: 'Merline Penhalewick',
      post: 'Junior Executive',
      email: 'mpenhalewick9@php.net',
      city: 'Kanuma',
      startDate: '04/19/2019',
      salary: '$15939.52',
    },
  ],
  tableSsr: [
    {
      id: 1,
      avatar: require('@/assets/images/avatars/10-small.png'),
      fullName: "Korrie O'Crevy",
      email: 'kocrevy0@thetimes.co.uk',
      startDate: '09/23/2016',
      salary: '$23896.35',
      status: 'Professional',
    },
    {
      id: 2,
      avatar: require('@/assets/images/avatars/1-small.png'),
      fullName: 'Bailie Coulman',
      email: 'bcoulman1@yolasite.com',
      startDate: '05/20/2018',
      salary: '$13633.69',
      status: 'Resigned',
    },
    {
      id: 3,
      avatar: require('@/assets/images/avatars/9-small.png'),
      fullName: 'Stella Ganderton',
      email: 'sganderton2@tuttocitta.it',
      startDate: '03/24/2018',
      salary: '$13076.28',
      status: 'Professional',
    },
    {
      id: 4,
      avatar: require('@/assets/images/avatars/3-small.png'),
      fullName: 'Dorolice Crossman',
      email: 'dcrossman3@google.co.jp',
      startDate: '12/03/2017',
      salary: '$12336.17',
      status: 'Applied',
    },
    {
      id: 5,
      avatar: require('@/assets/images/avatars/4-small.png'),
      fullName: 'Harmonia Nisius',
      email: 'hnisius4@gnu.org',
      startDate: '08/25/2017',
      salary: '$10909.52',
      status: 'Professional',
    },
  ],
  /* eslint-disable global-require */
}

mock.onGet('/good-table/basic').reply(() => [200, data.tableBasic])
mock.onGet('/good-table/row-group').reply(() => [200, data.tableRowGrp])
mock.onGet('/good-table/advanced-search').reply(() => [200, data.tableAdvancedSearch])
mock.onGet('/good-table/table_ssr').reply(() => [200, data.tableSsr])

const dataComplaint = {
  Result: true,
  Message: [
    {
      Complain_Code_ID: 'OCPB0164/00618',
      Complain_Date: '2021-01-11T00:00:00',
      Complain_Time: '13:10',
      CusIden: '1709900608196',
      Cusname: 'อทิตยา แหวกวารี',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ประสบอุบัติเหตุ ขี่ จยย. ตกหลุม ขุดท่อ ไม่มีสัญญาณ ป้าย และไฟแจ้งเตือน ประกัน บ่ายเบี่ยงความรับผิดชอบ ทาง บ.วรประดิษฐ์ และ ตำรวจแจ้งว่า ติดต่อ ประกันไม่ได้ คดีไม่คืบหน้า เกิดเหตุตั้งแต่ 12/8/2562',
      Complain_Details: 'ประสบอุบัติเหตุ ขี่ จยย. ตกหลุม ขุดท่อ ไม่มีสัญญาณ ป้าย และไฟแจ้งเตือน ประกัน บ่ายเบี่ยงความรับผิดชอบ ทาง บ.วรประดิษฐ์ และ ตำรวจแจ้งว่า ติดต่อ ประกันไม่ได้ คดีไม่คืบหน้า เกิดเหตุตั้งแต่ 12/8/2562\r\nอ้างถึง ผู้เอาประกันภัย บ.วรประดิษฐ์ จก. ลักษณะความเสียหาย ความรับผิดตามกฎหมาย วันที่เกิดเหตุ 12/08/2562 สถานที่เกิดเหตุ ถนนพัทยากลาง เคลมเลขที่ 19-01441-381 กรมธรรม์เลขที่ 719-23441-2\r\n\r\nและ\r\n\r\nhttps://m.facebook.com/story.php?story_fbid=2314736405511312&id=1421513211500307&sfnsn=mo',
      Company_Name: 'บริษัท กรุงเทพประกันภัย จำกัด (มหาชน) / Bangkok Insurance Public Co,. Ltd.',
      Send_Date: '2021-01-22T22:43:31',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/00492',
      Complain_Date: '2021-01-08T00:00:00',
      Complain_Time: '22:49',
      CusIden: '5100299046320',
      Cusname: 'เบญจพร เผดิมโชค',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'การดำเนินธุรกิจที่ไม่เป็นธรรมของบริษัทเอไอเอ',
      Complain_Details: 'ดิฉันได้ทำประกันกับบริษัทเอไอเอ เป็นแบบประกันภัยสะสมทรัพย์ 20 ปีตรีคูณ จำนวนเอาประกันภัยคือ 200,000 บาท วันที่กรมธรรม์ 3 มีนาคม 2543 และกรมธรรม์ครบสัญญา วันที่ 3 มีนาคม 2563 โดยจ่ายปีละ 22,100 บาท เป็นเวลา 7 ปี มีเงินคืนตอนปีที่ 5 ร้อยละ 20 (40,000 บาท) ซึ่งตามที่ตัวแทนเก่า ชื่อ ปิยะวรรณ คัยนันท์ ได้อธิบายตอนขายประกันคือ จ่าย 5 ปี ส่วนปีที่ 6 และ 7 จะเอาเงินคืนในปีที่ 5 มาจ่าย แล้วรอรับเงินคืนปีที่ 20 ต่อมา ปี 2549 นางปิยะวรรณ ได้ให้ดิฉันเซ็นสลักหลังกรมธรรม์ แล้วเอากรมธรรม์ดิฉันไป แล้วเอาบันทึกสลักหลังเย็บติดแมกซ์มาในกรมธรรม์ ซึ่งดิฉันไม่เข้าใจ แต่ก็ทำตามไปตามคำแนะนำของตัวแทน ซึ่งหลังจากปีที่ 5 ตัวแทนก็ไม่เคยติดต่อมาเพื่อเก็บเบี้ยดิฉันอีกเลย ซึ่งก็เป็นไปตามที่คุยกันตอนเสนอขายประกันว่าปีที่ 6 และปีที่ 7 จะเอาเงินที่คืนปีที่ 5 มาจ่าย หลังจากนั้น นางปิยะวรรณ ได้ลาออกจากการเป็นตัวแทน ซึ่งดิฉันพบว่า นางปิยะวรรณมีพฤติกรรมฉ้อโกงโดย รับเบี้ยจากลูกค้าไป แต่ไม่นำเงินไปจ่าย ทำให้บริษัทมาทำการกู้เงินอัตโนมัติให้ ซึ่งส่วนนี้ ดิฉันไม่เคยได้รับหนังสือจากทางบริษัท ถึงการเปลี่ยนแปลงใดๆในกรมธรรม์ กรมธรรม์ของดิฉันถูกโอนไปให้ตัวแทนใหม่ ชื่อคุณอุษา อัมพันศิริรัตน์ จนกระทั่ง เมื่อตอนต้นปี 2563 ดิฉันได้รับเงินคืนตามกำหนดระยะเวลา 20 ปี แต่เป็นเงินเพียง 123,383.88 บาท ดิฉันจึงได้ทำการสอบถามไปยังคุณอุษา ได้ความว่า ให้ไปดูใบสลักหลังในกรมธรรม์ ดิฉันจึงไปแกะแมกซ์ดู จึงพบว่ามีการระบุวงเงินประกันภัย 176,132 บาท เงินสะสมสุทธิ 123,383.88 บาท ซึ่งตรงกับจำนวนที่ได้รับ จึงสอบถามคุณอุษาไปว่าเกิดอะไรขึ้น ได้รับการอธิบายว่าต้องมีการสลักหลังเพื่อมิให้ไปทำการกู้เงิน ซึ่งเป็นการประกันภัยแบบขยายเวลา เมื่อทราบดังนั้น ดิฉันได้พยายามติดต่อนางปิยะวรรณ เพื่อขอคำอธิบาย ซึ่งนางปิยะวรรณแจ้งว่านับปีผิด ไปทำสลักหลัง ณ ปีที่ 6 ซึ่งต้องทำที่ปีที่ 7 มีผลให้การจ่ายเงินไม่ต่อเนื่อง และหยุดการจ่ายเงินไปก่อนถึงกำหนดจึงได้เงินประกันเพียงเท่านี้ ทั้งนี้ทั้งนั้น ไม่ใช่ความผิดของดิฉันเลย ดิฉันได้ทำเรื่องร้องเรียนไปที่บริษัทเอไอเอ ขอผ่อนปรนที่จะทำตามเงื่อนไขจนครบสัญญา โดยดิฉันยินยอมจะจ่ายส่วนที่ดิฉันต้องจ่ายเพิ่ม เพื่อให้กรมธรรม์มีผลตามเดิม แต่ บริษัทเอไอเอ ปฏิเสธที่จะรับผิดชอบ และแจ้งว่าจ่ายเงินครบถ้วนถูกต้อง ดิฉันไม่ได้มีประเด็นเรื่องของการจ่ายเงินของบริษัท แต่ต้องการร้องเรียนในจรรยาบรรณการดำเนินธุรกิจ เนื่องจากบริษัทเอไอเอปฏิเสธที่จะรับผิดชอบในการกระทำของตัวแทนที่ทำผิดต่อลูกค้า โดยลูกค้าไม่ได้รู้เรื่องใดๆกับการสลักหลังที่ต้องทำตามนโยบายของบริษัท และตัวแทนก็ยังเป็นผู้ที่หาผลประโยชน์จากลูกค้าให้กับบริษัท แต่บริษัทกลับไม่ยอมที่จะช่วยเหลือ ดิฉันได้ทำเรื่องร้องเรียนไปที่สำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย (คปภ.) บริษัทเอไอเอก็ยังปฏิเสธที่จะรับผิดชอบ โดยอ้างว่า เป็นเรื่องของตัวแทนไปคุยกับลูกค้า บริษัทไม่รับผิดชอบ ยึดตามเอกสารเท่านั้น อีกทั้งยังให้ดิฉันไปแจ้งความเอาผิดกับตัวแทนเก่าเอง ซึ่งที่ผ่านมาทางบริษัทไม่เคยแจ้งสถานะของกรมธรรม์ให้กับทางลูกค้าได้รับรู้ทั้งสิ้น การกู้เงินอัตโนมัติก็ไม่เคยได้รับทราบเลย ดิฉันคิดว่าบริษัทเอไอเอดำเนินธุรกิจอย่างไม่เป็นธรรม เอารัดเอาเปรียบกับลูกค้าที่ไม่รู้อิโหน่อิเหน่ และต้องมารับผลของการกระทำผิดของตัวแทนที่ทำเพื่อผลประโยชน์ของบริษัท ทั้งนี้ ด้วยเจ้าหน้าที่ของ คปภ มีข้อจำกัดด้านกฎหมายที่มิอาจชี้ขาดข้อพิพาทให้เป็นที่ยุติได้ จึงแนะนำให้ดิฉ้นไปยื่นคำร้องต่อศาลผู้คุ้มครองผู้บริโภค หรืออนุญาโตตุลาการ สำนักงาน คปถ ต่อไป',
      Company_Name: 'บริษัท เอไอเอ จำกัด',
      Send_Date: '2021-01-22T22:44:54',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/00354',
      Complain_Date: '2021-01-06T00:00:00',
      Complain_Time: '22:55',
      CusIden: '1411200005435',
      Cusname: 'ิพิศมัย พรมทา ',
      attorneyIden: '1411200005435',
      attorneyname: 'ิพิศมัย พรมทา ',
      Complain_Subject: 'บริษัทเมืองไทยประกันภัยจำกัด(มหาชน) และบริษัททีคิวเอ็มอินชัวร์รันส์ โบรคเกอร์จำกัด ประวิงเวลาการพิจารณา และปฏิเสธการลบรอยแผลเก่าของรถยนต์',
      Complain_Details: 'ดิฉันนางสาวพิศมัย พรมทา ถือบัตรประชาชนเลขที่ 14112 00005435  ครอบครองรถยนต์โตโยต้าวีออส ทะเบียน ขค 5624 \r\nได้ดำเนินการเข้ารับเคลมประกันภัยรถยนต์ ณ ศูนย์โตโยต้า สาขาบางบัวทอง  เมื่อวันที่  18/9/2563\r\nโดยมีเอกสารการเคลมดังนี้ \r\n1. เลขที่เรื่อง  06810508  วันที่  20/9/2561 \r\n2. เลขที่เรื่อง  06820413  วันที่  03/10/2561\r\n3. เลขที่เรื่อง  08014406  วันที่  03/06/2562\r\n\r\nทราบเรื่องจากเจ้าหน้าที่ คุณหทัยรัตน์  ศูนย์โตโยต้า สาขาบางบัวทอง เมื่อวันที่  6/11/2563 เวลา12.05น. แจ้งว่า เอกสารเคลมมีรายการที่ต้องชำระค่าใช้จ่ายเพิ่ม 50 % ของมูลค่าความเสียหาย\r\nและเมื่่อวันที่  21/11/2563 ดิฉันได้เข้าไปที่ศูนย์โตโยต้า สาขาบางบัวทอง เพื่อสอบถามรายละเอียดเพิ่ม จึงได้ทราบว่าเหตุที่ต้องชำระค่าใช้จ่ายเพิ่ม 50 % ของมูลค่าความเสียหายนั้้น เนื่องจากยังมีรอยแผลเก่าก่อนเข้ารับการเอาประกันภัย\r\nดิฉันจึงได้ชี้แจงและแสดงเอกสารหลักฐานต่อคุณหทัยรัตน์  ศูนย์โตโยต้า สาขาบางบัวทอง ว่าได้มีการเข้ารับการเคลมประกันสำหรับรอยแผลเก่านั้นแล้ว โดยมีเอกสารหลักฐานเป็นใบรับซ่อมรถและสี พร้อมใบเสร็จการรับรถ เมื่อวันที่ 15/09/2561 เพื่อแสดงให้เห็นว่าดิฉันได้เข้ารับเคลมและลบรอยแผลเก่านั้นแล้ว เมื่อเห็นเอกสารดังกล่าวแล้วคุณหทัยรัตน์  ศูนย์โตโยต้า จึงได้ประสานงานติดต่อเจ้าหน้าที่ของบริษัทเมืองไทยฯ ซึ่งแจ้งว่าให้ลูกค้าติดต่อไปที่ตัวแทน (บริษัททีคิวเอ็มอินชัวร์รันส์ โบรคเกอร์จำกัด ) เป็นผู้ส่งเรื่องเพื่อลบรอยแผลเก่านั้น และดิฉันก็ได้ติดต่อตัวแทนภายในวันนั้น โดยมีเจ้าหน้าที่ คุณณัฐประภา บริษัททีคิวเอ็มอินชัวร์รันส์ เป็นผู้รับเรื่อง โดยให้ส่งเอกสารหลักฐานผ่านอีเมล และดิฉันก็ดำเนินการส่งข้อมูลพร้อมเอกสารให้ในวันนั้น (21/11/20) หลังจากนั้นได้รับอีเมลวันจันทร์ที่ 23/11/20 จากคุณณัฐประภา บริษัททีคิวเอ็ม ว่าได้ดำเนินการส่งเรื่องให้แล้ว สามารถเข้าเช็คสถานะในวันที่ 24/11/20 ได้เลย ดิฉันจึงได้ส่งไลน์แจ้งให้คุณหทัยรัตน์  ศูนย์โตโยต้า สาขาบางบัวทอง ทราบและดำเนินการตรวจสอบข้อมูลให้ จากนั้น วันที่ 8/12/20 ได้รับข้อความทางไลน์จากคุณหทัยรัตน์  ศูนย์โตโยต้า แจ้งว่าได้ติดต่อบริษัทเมืองไทยให้แล้วและรับแจ้งว่ายังไม่มีข้อมูล จากนั้นดิฉันจึงได้โทรติดตามผลตามรายละเอียดดังนี้\r\nวันที่ 9/12/20 15.39 น ติดต่อเบอร์  1484  คุณรัชนก call center แจ้งโอนสายให้ call center รถยนต์ ปลายสายแจ้งว่าให้ติดต่อคุณนิวัตน์ เบอร์ 02 665 4000 ต่อ 4785 โดยติดต่อไปแล้วแต่ไม่มีผู้รับสาย\r\n                     16.49 น ติดต่อเบอร์  1737 เพื่อขอสายคุณณัฐประภา บริษัททีคิวเอ็มอินชัวร์รันส์ ปลายสายแจ้งว่าคุณณัฐประภา เบอร์ต่อ 55032 แล้วจะให้ติดต่อกลับแต่ก็เงียบ\r\nวันที่ 14/12/20 ติดต่อเบอร์  02 665 4000 ต่อ 4785 ไม่มีผู้รับสาย จึงติดต่อเบอร์ 1484 คุณแก้วตารับเรื่อง แจ้งจะตรวจสอบข้อมูลให้ และขอเบอร์ไว้เพื่อจะติดต่อกลับ แต่ก็เงียบ\r\nวันที่ 15/12/20 09.18น. ติดต่อเบอร์  02 665 4000 ต่อ 4785 ไม่มีผู้รับสาย จึงติดต่อเบอร์ 1484 คุณนีรนุชรับเรื่องแจ้งจะตรวจสอบข้อมูลให้ และขอเบอร์ไว้เพื่อจะติดต่อกลับ แต่ก็เงียบ\r\nวันที่ 16/12/20  09.34น. ติดต่อเบอร์ 1737 ต่อ 55032 เพื่อขอสายคุณณัฐประภา แจ้งว่าจะตามเรื่องให้วันที่ 18/12/20 น่าจะทราบผล \r\nวันที่ 21/12/20  13.20น. ติดต่อเบอร์ 1737 ต่อ 55032 เพื่อขอสายคุณณัฐประภา แต่มีเจ้าหน้าที่ท่านอื่นรับเรื่องแทนและจะให้คุณณัฐประภาติดต่อกลับ แต่ก็เงียบ\r\nวันที่ 22/12/20  16.09น. ติดต่อเบอร์ 1737 ต่อ 55032  ไม่มีผู้รับสาย จึงติดต่อ call center เพื่อขอสายคุณณัฐประภา แจ้งว่าจะให้ติดต่อกลับ แต่ก็เงียบ\r\nวันที่ 23/12/20  11.06น ติดต่อเบอร์  1737 ต่อ 55032 เพื่อขอสายคุณณัฐประภา แจ้งว่าต้องส่งเรื่องใหม่ โดยเลขที่เคสคือ 20201216585  คาดว่าน่าจะทราบผล 3-5 วัน\r\nวันที่ 28/12/20   16.15น. ติดต่อเบอร์ 1737 ต่อ 55032 คุณณัฐประภา บริษัททีคิวเอ็มอินชัวร์รันส์ แจ้งว่าดำเนินการเรียบร้อย ดิฉันจึงได้โทรแจ้งให้คุณหทัยรัตน์  ศูนย์โตโยต้า ทราบ\r\n                        และดำเนินการตรวจสอบข้อมูลให้ แต่เรื่องยังเงียบอยู่\r\nวันที่ 6/1/20    16.12น. ติดต่อเบอร์ 1484 call center รถยนต์ คุณบุษกรรับเรื่องแจ้งยังไม่มีข้อมูล\r\nซึ่งจาก time line นี้ ดิฉันได้พยายามติดตามผล เป็นระยะเวลาเกิน 1 เดือน เป็นเหตุให้เข้าใจได้ว่า บริษัทเมืองไทยประกันภัยจำกัด(มหาชน) และบริษัททีคิวเอ็มอินชัวร์รันส์ โบรคเกอร์จำกัด ประวิงเวลาการพิจารณาและปฏิเสธความรับผิดชอบการลบรอยแผลเก่าของรถยนต์ดังกล่าว ซึ่งเวลานี้ดิฉันจะต้องนำรถยนต์เข้ารับการซ่อมแซ่มแล้ว แต่ยังไม่มีความคืบหน้า และไม่ทราบระยะเวลาสิ้นสุด\r\nจึงจำเป็นต้องเสนอเรื่องร้องเรียนไปยังสำนักงานคณะกรรมการคุ้มครองผู้บริโภคเพื่อขอความอนุเคราะห์ติดตามเรื่องให้\r\n',
      Company_Name: 'บริษัทเมืองไทยประกันภัยจำกัด(มหาชน) และบริษัททีคิวเอ็มอินชัวร์รันส์ โบรคเกอร์จำกัด ',
      Send_Date: '2021-01-22T22:46:29',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/00996',
      Complain_Date: '2021-01-17T00:00:00',
      Complain_Time: '11:50',
      CusIden: '3930700084076',
      Cusname: 'บุญคล่อง หนูสังข์',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ตัวแทนประกันหลอกลวงให้ซื้อประกันชีวิต โดยรูปแบบประกันไม่ตรงกับที่ตกลงกันไว้',
      Complain_Details: 'เมื่อวันที่ 20 ม.ค. 2558 ข้าพเจ้าตัดสินใจซื้อกรมธรรม์ประกันภัยกับนางสุธารัตน์ พรหมดนตรี ซึ่งเป็นตัวแทนของบริษัทกรุงไทยแอกซ่า โดยได้ตกลงรูปแบบเป็นประกัน คือ ส่งค่าประกัน 5 ปี ปีละ 6 พันบาทแบ่งจ่าย 2 งวด หลังจากนั้นคุ้มครองตลอดชีพ ซึ่งนางสุธารัตน์ได้ส่งเล่มกรมธรรม์เป็นแบบคุ้มครองตลอดชีพ 99 (ชนิดไม่ปันผล) ซึ่งเมื่อเข้าสู่ปีที่ 7 ทางบริษัทยังดำเนินการส่งเอกสารให้ไปชำระเบี้ยประกันภัย ข้าพเจ้าจึงไปถามนางสุธารัตน์ อีกครั้งซึ่งได้ข้อมูลว่าให่ส่งต่ออีก 10 ปี ถึงจะเริ่มเวรคืนได้เงินเต็มจำนวน ข้าพเจ้าเลยโทรไปสอบถามกับบริษัทกรุงไทยแอกซ่าเพื่อยืนยันข้อมูล ทางบริษัทแจ้งว่ากรมธรรม์ที่ลูกค้าถือนั้นต้องจ่ายเงินไปตลอดชีพ หรือจนกว่าจะอายุครบ 99 ปี ซึ่งข้อมูลดังกล่าวถูกปกปิดจากตัวแทนขายประกัน ข้าพเจ้าเห็นว่าการกระทำดังกล่าวของนางสุธารัตน์ พรหมดนตรี มีเจตนาล่อลวง และหวังผลประโยชน์ให้ลูกค้าเข้าประกัน โดยประกันที่ตกลงไว้กับตัวเล่มคนละฉบับกัน เพื่อไม่ให้เกิดกรณีอย่างนี้ขึ้นอีกจึงขอร้องเรียนเรื่องดังกล่าว',
      Company_Name: 'ไม่ระบุ/ Unknow',
      Send_Date: '2021-02-01T10:48:42',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/00228',
      Complain_Date: '2021-01-05T00:00:00',
      Complain_Time: '16:20',
      CusIden: '3909800361665',
      Cusname: 'ศศธร อินทร์งาม',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ไม่ได้รับเงินเครมประกันคืนมาเป็นเวลา 1 เดือน กว่าๆแล้ว',
      Complain_Details: 'ราได้ทำการซื้อประกันชีวิตและสุขภาพจากบริษัทฟิลลิปประกันชีวิตให้แก่ลูกฝาแฝดของเรา 2 คน ตั้งแต่แรกเกิด คือช่วงเดือน มีนาคม 2563  เมื่อวันที่ 25 พฤศจิกายน 2563 ลูกฝาแฝดของเราได้เข้าแอดมิดที่ รพ จังหวัดสิงห์บุรี ด้วยโรค RSV และปอดอักเสบ ซึ่งเป็นโรคที่เพิ่งเกิดขึ้น ไม่ได้เป็นโรคมาแต่กำเนิด เราได้สำรองจ่ายเงินไปก่อนประมาณ 80,000 กว่าบาท และได้ส่งเอกสารตัวจริงทั้งหมดไปที่บริษัทฟิลลิปตั้งแต่วันที่ 7 ธ.ค. 63 ซึ่งจนกระทั่งวันนี้ ยังไม่มีการดำเนินการใดๆ หรือตอบรับอะไรเลยจากบริษัทฟิลลิป ไม่ได้เงินคืน ไม่ได้รับความอำนวยความสะดวก หรือติดตามผลอะไรให้เราเลย เราคอยโทรสอบถาม ก็ได้รับแต่คำตอบว่ากำลังดำเนินการ กำลังพิจารณา ยอดเงินไม่ใข่น้อยๆ เรามีความจำเป็นต้องใช้เงิน ผ่านมา 1 เดือน แล้ว ยังไม่ได้รับเงินคืนเลย ',
      Company_Name: 'บริษัท ฟิลลิปประกันชีวิต จำกัด (มหาชน) Phillips Insurance PCL.',
      Send_Date: '2021-02-01T10:52:43',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/00396',
      Complain_Date: '2021-01-07T00:00:00',
      Complain_Time: '15:18',
      CusIden: '1209700206170',
      Cusname: 'อลิษา  ชื่นดี',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'บริษัทประกันภัยปกิเสธจ่ายค่าสินไหมทดแทนโดยไม่มีเหตุผลอันสมควร',
      Complain_Details: 'เรื่อง ขอความช่วยเหลือ บริษัท ปฏิเสธไม่จ่ายเงินค่าสินไหมฯ \r\n\r\nเรียน เจ้าหน้าที่ผู้เกี่ยวข้อง\r\n\r\n\r\n     1.ข้าพเจ้า นางสาวอลิษา ชื่นดี  อายุ 33 ปี  โทร. 085 198 8665    ขอร้องเรียนบริษัท เจเนอราลี่ฯ  มีความจะกล่าวดังนี้\r\n\r\n  \r\n     2.เดิม นายสมศักดิ์ ชื่นดี (บิดาข้าพเจ้า ) ผู้เอาประกัน ได้เอาประกันไว้กับ บริษัท เจนเนอราลี่ ประกันภัย (ไทยแลนด์) จำกัด (มหาชน) (GENERALI) สำหรับรถยนต์หมายเลขทะเบียน ขค 4331 ชลบุรี เพื่อธนาคารเกียรตินาคิน โดยมีข้าพเจ้า นางสาวอลิษา ชื่นดี เป็นผู้รับผลประโยชน์ตามกรมธรรม์จำนวนเงินเอาประกัน 137,618 บาท เบี้ยประกันหลัก 4,082 บาท การชำระเบี้ยครั้งเดียว วันเริ่มสัญญาวันที่ 30 มีนาคม 2560 วันที่ครบกำหนดสัญญาประกันภัยวันที่ 30 มีนาคม 2564 ต่อมา นายสมศักดิ์ ชื่นดี ผู้เอาประกันภัย ได้เสียชีวิตลงแล้วนับแต่ วันที่ 12 กันยายน 2562 อันเป็นการเสียชีวิตภายในระยะเวลาคุ้มครองตามกรมธรรม์ประกันภัย\r\n\r\n    3. ข้าพเจ้าได้ติดต่อสอบถามขอรับค่าสินไหมทดแทนจากบริษัทฯมาตลอดแต่ถูกปฏิเสธอ้างว่าไม่มีสิทธิรับเงินโดยไม่ยอมส่งมอบหรือแสดงเหตุผลและหลักฐาน ล่วงเลยมาเป็นเวลากว่า 1 ปีแล้ว\r\n\r\n           จึงเรียนมายังท่านโปรดช่วยเหลือติดตามด้วย\r\n            ข้าพเจ้าได้แนบสำเนากรมธรรม์ และ สำเนาบัตรประจำตัวประชาชนมาด้วยแล้ว\r\n             ขอแสดงความนับถือ\r\n             อลิษา  ชื่นดี  ',
      Company_Name: 'บริษัท เจนเนอราลี่ ประกันภัย (ไทยแลนด์) จำกัด (มหาชน) / Generali Insurance (Thailand) Public Company Limited',
      Send_Date: '2021-02-01T11:46:54',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/01070',
      Complain_Date: '2021-01-18T00:00:00',
      Complain_Time: '18:42',
      CusIden: '1509900990599',
      Cusname: 'กริณภัทร คุณาธัมพ์',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ร้องเรียนการหลอกลวงผู้บริโภค ของ บริษัท วิริยะประกันภัย จำกัด (มหาชน)',
      Complain_Details: 'ข้าพเจ้า นายกริณภัทร คุณาธัมพ์ ชื่อเดิม นายกฤตพัส ธรรมปัญญา \r\n ผู้ถือกรรมธรรม์ประกัยภัยสุขภาพพ และอุบัติเหตุส่วนบุคคล \r\nกรรมธรรม์เลขที่ : 2018/POL/000624-587  \r\nPLAN :  BDMS LSPY 0003\r\n\r\nข้าพเจ้าได้ ทำการซื้อกรรมธรรม์เพื่อคุ้มครอง ตั้งแต่ 9 ตุลาคม 63 โดยทำเอกสารนำส่งเพื่อแจ้งความประสงค์ ให้ทางบริษัท วิริยะประกันภัย ตัดชำระผ่านบัตร เดบิต มาสเตอร์การ์ด ธนาคารกรุงเทพ  ต่อมาข้าพเจ้าแจ้งอายัติบัตรเดบิตเดิมเนื่องจากสูญหาย และได้ ติดต่อฝ่ายขาย คุณมด ซึ่งเป็นผู้ขายกรรมธรรม์แก่ข้าพเจ้า เพื่อเปลี่ยนแปลงข้อมูล ในช่วงเดือนพฤศจิกายน (ครั้งที่1)  และได้รับการตอบรับถึงความาสมบูรณ์ ในการเปลี่ยนแปลงข้อมูลดังปล่าวเป็นที่เรียบร้อย\r\nภายหลังจากนั้นเข้าสู่เดือนธันวาคม ข้าพเจ้าเกิดความสงสัยว่าทำไม ไม่มีการตัดชำระค่าประกันผ่านบัตรเดบิตตามที่ข้าพเจ้าได้แจ้งไป  จึงได้ติดต่อไปสอบถามความคืบหน้า จึงได้ข้อมูลว่า ให้ข้าพเจ้าส่งเอกสารใหม่อีกครั้ง ข้าพเจ้าจึงนำส่งผ่านทาง ไลน์ คุณมดอีกครั้ง (ครั้งที่ 2 )  ต่อมาทางคุณมดฝ่ายขาย ได้แจ้งกลับมาว่า สาเหตุที่ไม่สามารถ ตัดชำระได้ เนื่องจาก วิริยะประกันภัย ไม่สามารถใช้ร่วมกับบัตรเดบิตธนาคาร กรุงเทพได้ ขอให้ข้าพเจ้า แจ้งความจำนงค์ตัดชำระในบัตรอื่น อันเป็นเหตุให้ข้าพเจ้า แจ้งความประสงค์ใหม่อีกครั้งเป็น(ครั้ง ที่ 3 ) โดยประสงค์ให้ตัดชำระ ผ่านบัตรเดบิต ธนาคารไทยพาณิชย์  เป็นการแล้วเสร็จการแจ้ง และเปลี่ยนแปลงข้อมูล\r\n\r\nวันที่ 5 ม.ค. 64 ข้าพเจ้าติดต่อผ่านตัวแทนฝ่ายขาย คุณมด อีกครั้ง เพื่อสอบถามการใช้สิทธิ์รักษาพยาบาล แต่กลับโดนปฏิเสธการใช้สิทธิ์ สาเหตุที่ได้รับแจ้งคือ ข้าพเจ้าขาดการชำระเบี้ยประกันเกิน 57 วัน ซึ่งงทำให้ข้าพเจ้า ต้อง โอนชำระเงินสด เข้าบัญชีบริษัท แทนเพื่อต่ออายุกรรมธรรม์ แต่ก็ไม่สามารถใช้สิทธิ์ได้เลย ต้องรออนุมัติ ตามขั้นตอนของบริษัท ฯ ซึ่งข้อพเจ้าพยายามร้องขอการใช้สิทธิ์เนื่องจากมีอาการป่วย และต้องการเข้ารับการรรักษาโดยด่วน แต่ก็คงได้รับการปฏิเสธ แม้ว่าความผิดพลาดดังกล่าวจะเกิดขึ้นจากกระบวนการ และการทำงานของเจ้าหน้าที่ วิริยะประกันภัย ก็ตาม โดยไม่ใช่ความผิดของข้าพเจ้า   แต่ก็ไม่สามารถช่วยหรือดูแลข้าพเจ้าได้แบบทันท่วงที  โดยข้าพเจ้าได้สอบถาม และค้นหาข้อมูลอีกครั้ง ปรากฏว่า บัตรที่ไม่สามารถตัดชำระได้ นั้น คือบัตรเดบิต กรุงเทพ Union Pay ซึ่ง ข้าพเจ้าได้แจ้งไปยังตัวแทน คุณมด แล้วว่าบัตรเดบิตของข้าพเจ้า นั้นไม่ใช่ Union Pay แต่เป็น  Master Card ซึ่งได้รับการยืนยันว่าสามารถตัดชำระได้ แต่ทางตัวแทนก็ยังยืนยันว่าไม่สามารถ ตัดชำระได้ หากกเป็นบัตรเดดบิตกรุงเทพ \r\n\r\n\r\n\r\nข้าพเจ้า โทรแจ้งร้องเรียนกว่า 5 สาย และกว่า 2 หน่วยงาน ทั้ง Call center และศูนย์ร้องเรียน เพื่อให้รับการประสานงาน \r\nข้อร้องเรียนของข้าเจ้า ดังนี้ \r\n-\tความผิดพลาดที่เกิดขึ้นเกิดจาก วิริยะประกันภัย ไม่ใช่ของข้าพเจ้า ขอให้ทางวิริยะประกันภัย ดำเนินการตัดชำระผ่านบัตรเดบิต เพื่ออำนวยความสะดวกให้แก่ข้าพเจ้าที่ไม่ได้เป็นผู้ผิด  แต่ก็ได้รับการปฏิเสธ แม้ข้าพเจ้าจะร้องขอ และแจ้งว่าไม่สะดวกโอนชำระเงินสดก็ตาม \r\n-\tข้าพเจ้าร้องขอการดูแลที่เกิดขึ้นจากความผิดพลาดของเจ้าหน้าที่ของวิริยะ แต่ก็ไม่ได้รับการดูและใดใด\r\nทั้งนี้ข้าพเจ้าได้รับการเพิกเฉยต่อข้อร้องเรียนและการดูแลอันเกิดจากความผิดพลาดของพนักงานวิริยะประกันภัย \r\nข้าพเจ้าป่วย และต้องเข้ารับการรักษา โดยไม่สามารถรอการดูแลหรือแก้ไขจากทางวิริยะประกันภัยได้ \r\nจนกระทั่ง วันศุกร์ ที่ 15 ม.ค. 64 เวลา 14.57 น. ข้าเจ้าได้รับข้อความทางโทรศัพท์ ความว่า “กรมธรรม์ประกันสุขภาพของท่าน สิ้นสุดความคุ้มครอง เนื่องจากไม่สามารถหักชำระค่าเบี้ยได้”\r\nข้าพเจ้า ได้ติดต่อไป ยังหมายเลข 02-4228888 อีกครั้งเพื่อขอเหตุผล ปรากฏได้รับคำตอบถึงการจะประสานงานหาคำตอบให้เร็วที่สุด ซึ่ง ณ ขณะปัจจุบัน จันทร์ ที่ 18 ม.ค. 64 เวลา 18.19 น. (เวลาที่ข้าพเจ้าร้องเรียนยัง สบค.) ก็ยังไม่ได้รับการติดต่อใดใด เพื่ออธิบาย แก้ไข หรือดูแล \r\n\r\nข้าพเจ้าจึงขอร้องเรียนการกระทำดังกล่าวของวิริยะประกันภัย ในการหลอกลวงผู้บริโภค และเพิกเฉยต่อการแก้ไขความผิดพลาดที่เกิดขึ้นจากเจ้าหน้าที่ของวิริยะเอง \r\n\r\nขอแสดวงความนับถือ และหวังว่าจะได้รับความยุติธรรม เพื่อสร้างบรรทัดฐานความถูกต้องต่อไป \r\n',
      Company_Name: 'บริษัท วิริยะประกันภัย จำกัด (มหาชน) / The Viriyah Insurance Public company Limited.',
      Send_Date: '2021-02-01T11:48:07',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/00822',
      Complain_Date: '2021-01-13T00:00:00',
      Complain_Time: '20:32',
      CusIden: '3841600304271',
      Cusname: 'นพมาศ ฐิตโสมกุล',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'อู่ประกันภัยทำสีไม่เหมือนสีรถเดิม ออกเป็นสีเหลืองทั้งที่สีเดิมเป็นสีขาว ได้คุยกับอู่แล้วโดยนำรถไห้อู่แก้ไขแต่ได้รับการปฏิเสธ',
      Complain_Details: 'ต้องการไห้สีฝากระโปรงรถด้านหลังเหมือนสีหลังคารถ และสีแก้มรถซ้ายขวาด้านหลัง \r\nเอกสารร้องเรียน คปภ มี รายละเอียดของ ปัญหา และ การเกิดเหตุ แนบมาด้วยแล้ว\r\nอู่ในเครือของประกันอลิอันซ์ คือ อู่เขียวออโต้การาจ อยู่ที่ ซอยแบริ่ง จ.สมุทรปราการ โทร 0993265115',
      Company_Name: 'สำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย(คปภ.)',
      Send_Date: '2021-02-01T11:51:06',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/00185',
      Complain_Date: '2021-01-05T00:00:00',
      Complain_Time: '11:00',
      CusIden: '3320700043138',
      Cusname: 'กฤตภพ วิเศษศิลป์',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'กรุงไทย-แอกซ่า ประกันชีวิต หักเงินกู้อัตโนมัติเพื่อชำระเบี้ยประกันจากกรมธรรม์',
      Complain_Details: 'ข้าพเจ้า จ่าเอกกฤตภพ วิเศษศิลป์ ผู้เอาประกันภัย ตามกรมธรรม์เลขที่ 505-817667 แบบไอ-โพรเทค5 (ชนิดไม่มีเงินปันผล) 5WL57 และสัญญาเพิ่มเติมคุ้มครองโรคร้ายแรง ตามแบบ ELI48 แบบรายปี นั้น  ข้าพเจ้าได้รับใบแจ้งครบกำหนดชำระเบี้ยประกัน วันที่ออกใบแจ้ง 6 ตุลาคม 2563  วงเงิน 3,236บาท ต่อมาเมื่อวันที่ 18 ธันวาคม 2563  ออกใบเสร็จรับเงิน เลขที่ 0003737496 แจ้งว่าได้หักจากเงินอื่นๆ เงินกู้อัตโนมัติเพื่อชำระเบี้ยประกัน   และมีหนังสือแจ้ง สถานะกรมธรรม์ ว่าทางบริษัทได้ทำการกู้เงินอัตโนมัติเพื่อชำระเบี้ยประกันนี้ จะทำให้เกิดเป็นหนี้สินคงค้างในกรมธรรม์เช่นเดียวกับการกู้ยืมเงินจากกรมธรรม์นั้น   ถามว่า\r\n1.\tการหักจากเงินอื่นๆ เงินกู้อัตโนมัติเพื่อชำระเบี้ยประกัน ทำได้อย่างไร ทั้งที่เจ้าของกรมธรรม์ไม่ได้รับทราบว่าจะหัก หรือยืนยันหรือยินยอมให้หักเงินกู้อัตโนมัติแต่อย่างใด\r\n2.\tในการกู้เงินจากกรมธรรม์ต้องจัดเตรียมเอกสารหลักฐานประกอบการกู้ แต่ทางบริษัทหักเงินกู้อัตโนมัติกลับไม่ต้องใช้เอกสารใดเลย\r\n3.\tข้าพเจ้าต้องมีภาระในการกู้เงินอัตโนมัติ เพราะเกิดเป็นหนี้สินคงค้างในกรมธรรม์ ซึ่งคิดอัตราดอกเบี้ยทบต้นในอัตราสู่งกว่าอัตราดอกเบี้ยที่ใช้ในการคำนวณเบี้ยประกันอีกร้อยละ 2 ต่อปี\r\n4.\tตามใบเสร็จรับเงินที่แจ้ง จำนวนเงินเบี้ยประกันรวม 3,236บาท มีรายละเอียดตามนี้\r\n4.1\tค่าเบี้ยประกันภัยสุขภาพ  จำนวนเงิน  2,359.37 บาท  เดิมทำประกันครั้งแรก  เป็นเงิน 2,270บาท ส่วนที่เกินมาคืออะไร\r\n4.2\tค่าเบี้ยประกันภัยตามสัญญาเพิ่มเติมอื่น จำนวนเงิน  876.63 บาทส่วนนี้เป็นค่าอะไร\r\n5.\tส่วนทางบริษัทที่ได้ดำเนินการหักเงินกู้โดยมิชอบนั้น จะดำเนินการอย่างไร\r\n                     ข้าพเจ้าจึงขอความเป็นธรรม และมีความประสงค์จะเปลี่ยนแปลงแก้ไขประกันภัย ตามกรมธรรม์เลขที่ 505-817667 แบบไอ-โพรเทค5 (ชนิดไม่มีเงินปันผล) 5WL57 และสัญญาเพิ่มเติมคุ้มครองโรคร้ายแรง ตามแบบ ELI48 แบบรายปี โดยการยกเลิกสัญญาเพิ่มเติมคุ้มครองโรคร้ายแรง ตามแบบ ELI48 แต่ยังคงประกันภัยตามแบบไอ-โพรเทค5 (ชนิดไม่มีเงินปันผล) 5WL57  ที่ได้ชำระเงินครับตามสัญญานั้น ไว้เหมือนเดิม\r\n\r\n',
      Company_Name: 'บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน) / KRUNGTHAI-AXA LIFE',
      Send_Date: '2021-02-08T09:35:40',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/01985',
      Complain_Date: '2021-01-31T00:00:00',
      Complain_Time: '13:34',
      CusIden: '1419900444706',
      Cusname: 'วัชรพงษ์ วงษ์เสียงดัง',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ประกันจ่่่ายแค่40%ค่าลักษา140,000จ่ายแค่60,000',
      Complain_Details: 'ประกันจ่่่ายแค่40%ค่าลักษา140,000จ่ายแค่60,000ตอนเข้าลักษาบอกจะออกให้หมดจ่ายแค่ค่าส่วนต่างก็พอ',
      Company_Name: 'บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน) / KRUNGTHAI-AXA LIFE',
      Send_Date: '2021-02-08T09:36:18',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/01890',
      Complain_Date: '2021-01-29T00:00:00',
      Complain_Time: '12:54',
      CusIden: '3130400119904',
      Cusname: 'สุนีย์ ทองรุ่งงาม',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ไกล่เกลี่ยค่าสินไหมทดแทน',
      Complain_Details: 'นางสาว สุนีย์ ทองรุ่งราม ( ผู้ร้องทุกข์ ) แจ้งว่าเมื่อวันที่ 19 ธันวาคม 2563\r\nผู้ร้องได้ซื้อรถยนต์ยี่ห้อ MAZDA  รุ่น MAZDA 2 สีขาว ทะเบียน 2กธ61  เลขตัวถัง MM8DL28S3AOW401411\r\nได้ประสบอุบัติเหตุชนทำให้ให้รถเสียหาย โดยได้แจ้งค่าประกันความเสียหาย\r\nกับบริษัท ไทยศรีประกันภัย จำกัด (มหาชน) เป็นจำนวนเงิน 14,000 บาท\r\nโดยผู้ร้องฯได้รับความเสียหายโดยแจ้งค่าเสียหายวันละ 1,000 บาท จำนวน 14 วัน เป็นจำนวนเงิน 14,000 บาท ซึ่งบริษัทฯได้ประเมินค่าใช้จ่ายเป็นจำนวนเงิน 3,500 บาท ซึ่งไม่เพียงพอกับค่าใช้จ่ายจริงที่แจ้งไป  ผู้ร้องฯจึงขอร้องทุกข์ต่อ สคบ. เพื่อเป็นหน่วยงานกลางในการเจรจาไกล่เกลี่ย\r\nและคืนเงินให้แก่ผู้ร้องเป็นจำนวนเงินทั้งสิ้น รวมเป็นจำนวน 14,000 บาท พร้อมดอกเบี้ยตามกฎหมาย\r\n(รายละเอียดปรากฏตามบันทึกคำร้องลงวันที่ 29 มกราคม 2564 จำนวน 2 แผ่น)\r\n*** หมายเหตุ ผู้ร้องฯยืนยันประสงค์จะยื่นคำร้อง ที่ สคบ. ส่วนกลาง ***\r\nเอกสารที่ใช้ประกอบการร้องทุกข์\r\n1. สำเนาบัตรประชาชน จำนวน 1 แผ่น\r\n2. สำเนาจดทะเบียนรถ จำนวน 1 แผ่น\r\n3. สำเนากรมธรรม์ จำนวน 1 แผ่น\r\n4.สำเนาใบส่งซ่อม จำนวน 1ชุด\r\n5.สำเนาแจ้งผิดพิจาณาค่าสินไหม 1 แผ่น\r\nเอกสารอื่นๆ จำนวน 1 แผ่น\r\n',
      Company_Name: 'บริษัท ไทยศรีประกันภัย จำกัด (มหาชน) / Thaisri Insurance Public Co,. Ltd.',
      Send_Date: '2021-02-08T09:38:15',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/01950',
      Complain_Date: '2021-01-30T00:00:00',
      Complain_Time: '09:59',
      CusIden: '3100200064448',
      Cusname: 'หัธยา ธรรมนายกาธิป',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ประกันอุบัติเหตุ5 ปีแจ้งยกเลิก ในปีที่4 แจ้งว่านโยบายบริษัท',
      Complain_Details: 'ผู้ร้องทำการซื้อประกันอุบัติเหตุส่วนบุคคล จาก อลิอันซ์ อยุธยา ประกันภัย โดยกรมธรรม มีอายุ คุ้มครอง 3ปี 12/11/2018-12/11/2021 กรมธรรม์ประกันภัยเลขที่ 001-MS-2018-0051775\r\nทางบริษัทฯ แจ้งมาว่ามีการเรียกร้องค่าสินไหมจากผู้ร้อง ถือว่ามีความเสี่ยงสูงเกินกว่าที่จะรับประกันภัยได้ จึงส่งจดหมายมายกเลิกกรมธรรม์ โดยจะสิ้นสุดการคุ้มครอง วันที่ 22/02/2021',
      Company_Name: 'บริษัท ศรีอยุธยา เจนเนอรัล ประกันภัย จำกัด ',
      Send_Date: '2021-02-08T09:40:17',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/01724',
      Complain_Date: '2021-01-27T00:00:00',
      Complain_Time: '13:46',
      CusIden: '3100602109641',
      Cusname: 'วรางคณา เลิศสินไทย',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'บริษัท ซีเอสที 2019 (ประเทศไทย) จำกัด ไม่ยื่นเรื่องต่อกรรมธรรม์ ชั้น 1 พร้อม พ.ร.บ. ตามที่ได้ตกลงกันไว้ และไม่รับผิดชอบค่าเสียหายที่เกิดจากการไม่ยื่นเรื่องต่อกรมธรรม์',
      Complain_Details: 'เมื่อกลางปี 2563 มีพนักงานขายอ้างว่าชื่อ นางสาว จิราพร นามสกุล บุตรดี หรือ วฤทธิ์ โทรศัพท์มาเสนอขายกรมธรรม์ประภัยรถยนต์ชั้น 1 โดยอ้างว่าโทรจากบริษัท เอเอสเอ็น ซึ่งต่อมา ทั้งสองฝ่ายได้ตกลงซื้อขายกรมธรรม์ประกันภัยรถยนต์ชั้น 1 พร้อม พ.ร.บ. ของบริษัท เมืองไทยประกันภัย จำกัด และได้ชำระเงินเต็มจำนวน รวม 17,900 บาท ผ่านทางบัตรเครดิต โดยมีเจ้าหน้าที่มาเก็บเงิน ณ ที่ทำงานของข้าพเจ้า เมื่อวันที่ 24 มิถุนายน 2563 โดยตกลงว่า จะมีผลคุ้มครองต่อจากกรมธรรม์เดิมที่จะหมดอายุในวันที่ 21 ธันวาคม 2563 แต่มีข้อสังเกตว่า ใบเสร็จรับเงินออกในนามบริษัท ซีเอสที 2019 (ประเทศไทย) จำกัด ตั้งอยู่ที่ 59/223 ม.4 แขวงกระทุ่มราย เขตหนองจอก กทม. ซึ่งข้าพเจ้าได้โทรไปสอบถามกับ นางสาวจิราพรฯ ซึ่งนางสาวจิราพรฯ ได้ปฏิเสธว่า ไม่เคยแจ้งลูกค้าว่า โทรมาจากบริษัท เอเอสเอ็น \r\n\r\n \tต่อมา เมื่อวันที่ 29 ธันวาคม 2563 เวลาประมาณ 19.00 น. เกิดอุบัติเหตุกับรถยนต์ของข้าพเจ้า ดังนั้น จึงได้โทรไปแจ้งอุบัติเหตุกับบริษัท เมืองไทยประกันภัย จำกัด ปรากฏว่า ได้รับแจ้งจากพนักงานของบริษัทฯ ว่า ทะเบียนรถนี้ไม่มีกรมธรรม์กับบริษัทฯ แต่อย่างไรก็ตาม จะจัดส่งเจ้าหน้าที่ไปตรวจสอบเหตุและรับเรื่องไว้ก่อน ข้าพเจ้าจึงได้โทรไปสอบถามกับนางสาวจิราพรฯ และได้รับแจ้งว่า อยู่ระหว่างดำเนินการส่งเรื่องขอกรมธรรม์ต่อไปยังนายหน้าหรือบริษัทตัวแทนอีกที จึงทราบว่า นางสาวจิราพรฯ พนักงานของบริษัท ซีเอสที 2019 (ประเทศไทย) จำกัด ไม่ได้ยื่นเรื่องต่อกรมธรรม์ให้ตามที่ตกลงกันไว้ ตั้งแต่เดือนมิถุนายน 2563 เพื่อให้มีผลต่อในวันที่ 21 ธันวาคม 2563 ทั้งนี้ นางสาวจิราพรฯ ได้แจ้งกับข้าพเจ้าว่า จะดำเนินการขอกรมธรรม์ย้อนหลังให้ ซึ่งจะทำให้สามารถเคลมประกันภัยเกี่ยวกับอุบัติเหตุ เมื่อวันที่ 29 ธันวาคม 2563 ได้ พร้อมทั้งจะจ่ายค่าขาดประโยชน์จากการที่ไม่สามารถใช้รถยนต์ในช่วงที่รอเลขกรมธรรม์ดังกล่าว\r\n\r\n \tโดยข้าพเจ้า ได้มีการติดตามความคืบหน้ากับนางสาวจิราพรฯ อย่างต่อเนื่อง แต่ไม่มีความคืบหน้า จนกระทั่งมีการเปลี่ยนตัวผู้ประสานงานกับข้าพเจ้า อ้างว่าชื่อ นางสาวณัชชา นามสกุล ประยูรรัตน์ ต่อมา นางสาวณัชชาฯ ได้แจ้งให้ข้าพเจ้านำรถยนต์ไปประเมินค่าซ่อมแซมที่ศูนย์บริการฯ เนื่องจากกรมธรรม์ประกันภัยรถยนต์ไม่สามารถต่อย้อนหลังได้ โดยบริษัท ซีเอสที 2019 (ประเทศไทย) จำกัด จะเป็นผู้จ่ายเงินค่าซ่อมแซมดังกล่าวแทน ซึ่งข้าพเจ้า ได้นำรถยนต์ไปประเมินราคาค่าซ่อมแซม โดยมียอดประเมินประมาณ 56,000 บาท และได้ส่งเอกสารประเมินราคาไปยังนางสาวณัชชาฯ พร้อมทวงถามค่าขาดประโยชน์จากการที่ไม่สามารถใช้รถยนต์ได้ ซึ่งข้าพเจ้าได้มีการติดตามและสอบถามกับนางสาวณัชชาฯ อย่างต่อเนื่อง จนกระทั่งไม่สามารถติดต่อได้ สุดท้ายได้ไปแจ้งความฐานฉ้อโกงกับบริษัท ซีเอสที 2019 (ประเทศไทย) จำกัด และบุคคลที่เกี่ยวข้อง เมื่อวันที่ 25 มกราคม 2564 พร้อมทั้งขอให้ทางตำรวจตรวจสอบกับ คปภ. ว่า ได้รับอนุญาตให้เป็นผู้ดำเนินการขายกรมธรรม์ประกันภัยรถยนต์หรือไม่ด้วย\r\n\r\n \tข้าพเจ้า จึงขอร้องเรียนบริษัท ซีเอสที 2019 (ประเทศไทย) จำกัด และบุคคลที่เกี่ยวข้องดังกล่าวข้างต้น พร้อมทั้งให้รับผิดชอบค่าซ่อมแซมรถยนต์และค่าขาดประโยชน์จากการที่ไม่สามารถใช้รถยนต์ได้ รวมทั้งขอให้ สคบ. ประสาน/ตรวจสอบใบอนุญาตตัวแทน/นายหน้าของบริษัท ซีเอสที 2019 (ประเทศไทย) จำกัด และบุคคลที่เกี่ยวข้องข้างต้น เพื่อให้หน่วยงานที่เกี่ยวข้องดำเนินการตามอำนาจหน้าที่ต่อไป\r\n',
      Company_Name: 'บริษัท ซีเอสที 2019 (ประเทศไทย) จำกัด',
      Send_Date: '2021-02-08T09:42:23',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/01385',
      Complain_Date: '2021-01-22T00:00:00',
      Complain_Time: '16:24',
      CusIden: '3100800131227',
      Cusname: 'พชรธรณ์ อภิบาลทรัพย์ทวี',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ร้องเรียนบริษัทประกันภัยไม่ปฎิบัติตามสัญญากรมธรรม์',
      Complain_Details: 'ชอร้องทุกข์ต่อ บมจ.อลิอันซ์ อยุธยา ประกันภัย เลขที่ตั้ง 898 อาคารเพลินจิตรทาวเวอร์ ชั้น 1 ถ.เพลินจิตร แขวงลุมพินี เขตปทุมวัน กทม. 10330\r\n\r\nด้วยเหตุที่ถูกบริษัทฯดังกล่าวปฎิเสธการเคลมเปลี่ยนอุปกรณ์ ทั้งที่ทางศูนย์บริการที่ทางข้าพเจ้าได้นำรถยนต์เข้าไปทำการส่งซ่อมนั้น แจ้งกลับมาว่าไม่สามารถทำการซ่อมแซมได้ ต้องเปลี่ยนอุปกรณ์เท่านั้น แต่่ทางบริษัทประกันภัยดังกล่าว กลับยืนยันที่จะส่งซ่อมแซม โดยจะนำอุปกรณ์ไปส่งซ่อมกับร้านที่รับซ่อมภายนอก ทีี่ไม่ใช่ศูนย์บริการ (ข้าพเจ้าทำประกันภัยชั้น 1 เงื่อนไขการซ่อมศูนย์บริการ) กลับเป็นร้านภายนอก ซึ่งผิดเงื่อนไขการทำประกันภัย (จ่ายเบี้ยที่แพงกว่าปกติ แต่กลับได้รับการบริการในราคามาตรฐาน) โดยได้มีการติดตามผลการพิจารณามาอย่างต่อเนื่อง แต่ก็ยังได้รับคำตอบเดิมคือจะส่งซ่อมเท่านั้น ซึ่งทางข้าพเจ้าขอยืนยันการเปลี่ยนอุปกรณ์เท่านั้น หากจะซ่อม ผู้ที่จะซ่อมต้องเป็นนามศูนย์บริการที่ข้าพเจ้าได้นำรถเข้าไปเท่านั้น\r\n\r\nจึงเรียนมาเพื่อโปรดพิจารณา',
      Company_Name: 'บริษัท อลิอันซ์ อยุธยา ประกันภัย จำกัด (มหาชน) (ALLIANZ AYUDHYA GENERAL INSURANCE PUBLIC COMPANY LIMITED)',
      Send_Date: '2021-02-08T09:46:07',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/02113',
      Complain_Date: '2021-02-02T00:00:00',
      Complain_Time: '14:53',
      CusIden: '3200100108574',
      Cusname: 'ฉิมพลี วิมลธรรม',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'บริษัทโปกเกอร์ประกันภัยรถยนตร์รับเงินแล้วไม่ส่งกรมธรรม์',
      Complain_Details: 'ดิฉันซื้อรถยนต์ หมายเลขทะเบียนรถ 9 กน 6539 เมื่อเดือนพฤศจิกายน ปี 2562 โปรโมชั่นแถมการประกันภัยชั้น 1 ให้  หลังจากนั้นเมื่อเดือนมิถุนายน  2563 ดิฉันได้รับการติดต่อจากโบกเกอร์ประกันภัย (บริษัท C S T ประเทศไทย ) โดยอ้างว่าดูแลเรื่องประกันภัยคันนี้ โทรศัพท์มาหลายครั้งเพื่อให้ดิฉันต่อประกันกับบริษัทเดิมคือโตเกียวมารีน แต่ดิฉันก็ยังไม่ตกลงเพราะเห็นว่ายังมีเวลาอีกนานกว่าจะหมดระยะเวลาคุ้มครอง ทางโปกเกอร์ก็มีข้อเสนอให้เบี้ยประกันราคาพิเศษ สามารถผ่อนชำระผ่านบัตรเครดิตธนาคารกรุงไทย  ในราคา 17,900 บาท เวลา 6 งวด โดยไม่เสียดอกเบี้ย เมื่อตกลงทางบริษัทได้ให้พนักงานนำเครื่องรูดบัตรมาถึงบ้าน โดยมิได้มอบเอกสารใดๆ บอกว่าทางบริษัทจะจัดส่งภายหลัง  แต่พอชำระจริง 6 งวด ทางบริษัทได้ผลักดอกเบี้ยที่ต้องจ่าย เป็นเงิน 18,101.02 บาท เมื่อครบกำหนดกรมธรรม์หมดอายุ ได้โทรถามพนักงาน แต่ก็บอกว่ากำลังดำเนินการประกันกับบริษัทเมืองไทยประกันภัย จนเมื่อเดิอนธันวาคม มีอุบัติเหตุ ดิฉันได้โทรไปที่บริษัทเมืองไทย แจ้งว่ายังไม่มีข้อมูลการประกันรถของดิฉัน จึงโทรหาทางบริษัทแต่ก็ได้รับคำตอบเหมือนเดิมว่ากำหลังประสาร ครั้งแรกเมื่อเดือนปลายธันวาคมพนักงานชื่อพิมพ์ประภา ดิฉันขอร้องเค้าให้จัดการเรื่องพรบ. รถยนต์ก่อนไม่มีมันผิดกฏหมายเพราะกังวลมาก  ทางบริษัทจัดการให้ดำเนินการต่อทะเบียนให้ แต่ก็ไม่ติดต่อกลังมา โทรไม่รับสาย ไลน์ไปไม่ตอบ  และบอกให้รอประกันภัย  คนที่ 2 ดิฉันโทรเข้าทางบริษัทพนักงานชื่อณัชชา เมื่อวันที่ 15 มกราคม   รับปากว่าจะดำเนินการ แต่ก็เงียบหายโทรไปไม่รับ ไลน์ไม่ตอบเช่นเคย ดิฉันจึงโทรไปบริษัท  จนวันที่ 28 มกราคม คนที่ 3  ผู้รับสายคือเขมมิกกา รับเรื่อง แล้วเงียบไป  ดิฉันโทรไปตามได้รับคำตอบว่าจะคืนเงินให้ จนวันนี้ยังไม่ได้รับการประสานจากบริษัทนี้เลย ดิฉันเดือดร้อนมาก ในสภาวะแบบนี้เงินที่เสียไปก็มากพอสมควร แล้วถ้าต้องให้เสียใหม่ ตอนนี้ดิฉันขับรถอย่างไม่มั่นใจเลย \r\n    ขอความกรุณาช่วยตามเรื่องให้ด้วยค่ะ \r\nที่อยู่ของบริษัท ซีเอสที 2019 (ประเทศไทย) จำกัด\r\n59/223 ม.4 แขวงกระทุ่มราย เขตหนองจอก กรุงเทพ 10530 \r\nโทร 065 59487 และ 065 5915457',
      Company_Name: 'บริษัท ซีเอสที 2019 (ประเทศไทย) จำกัด',
      Send_Date: '2021-02-08T09:50:42',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/02896',
      Complain_Date: '2021-02-15T00:00:00',
      Complain_Time: '17:18',
      CusIden: '3440900609100',
      Cusname: 'ประมูล จันทศรี',
      attorneyIden: '3409700006876',
      attorneyname: 'วรรณศิริ เอี่ยมไกรอมร',
      Complain_Subject: 'ร้องทุกข์ขอความเป็นธรรม นางวรรณศิริ เอี่ยมไกรอมร',
      Complain_Details: 'ผู้ร้องได้ซื้อประกันภัย กับทางบริษัท อเมริกันอินเตอร์แนชชั่นแนลแอสชัวรันส์ จำกัด (AIA) ตกลงทำสัญญาแบ่งการคุ้มครอง เป็น 3 ประเภท 1.ประกันชีวิตตลอดชีพ 2.คุ้มครองการยกเว้นเบี้ยประกันกรมธรรม์หลักและ 3. คุ้มครองโรคร้ายแรง และข้อร้องเรียนให้ความเป็นธรรมกับนางวรรณศิริฯ ผู้เอาประกัน โดยมีคำสั่งให้บริษัท อเมริกันอินเตอร์แนชชั่นแนลแอสชัวรันส์ จำกัด (AIA)ให้ถือเอากรมธรรมืประกันหมายเลขที่ T079944155 ลงวันที่ 13 มิ.ย. 2540 มีผลผูกพันตามข้อความสัญญากรมธรรม์"...แบบการประกัยภัย ตลอดชีพ ชำระเบี้ยประกันภัย 20 ปี 13 มิ.ย. 2540 วันที่ทำสัญญาประกันภัย..." และบริษัทมีหน้าที่จ่ายเงินเอาประกัน จำนวน 500,000 บาทให้กับทายาทวรรณศิริฯ กรณีเสียชีวิต รายละเอียดตามเอกสารแนบ',
      Company_Name: 'บริษัท อเมริกันอินเตอร์แนชชั่นแนลแอสชัวรันส์ จำกัด (AIA) / American International Assurance Co.,Ltd. (Thailand)',
      Send_Date: '2021-02-16T08:22:29',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/02172',
      Complain_Date: '2021-02-03T00:00:00',
      Complain_Time: '13:21',
      CusIden: '1620400165514',
      Cusname: 'วัชรากรณ์ โทรักษา',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ไม่ได้รับความเป็นธรรม กับบริษัทประกันภัยวิริยะกับค่าสินไหม',
      Complain_Details: 'ทำประกันอุบัติเหตุกับวิริยะไว้    ปีละ400  พอเกิดอุบัติเหตุ  นิ้วก้อยขาด1ข้อ  ยืนเรื่องเอาประกันตัวที่ทำไว้  แต่มีผลกลับมาว่าจ่ายไม่ได้ไม่เข้ากับความคุ้มคลอง  ทั้งที่ในรายระเอียดคุ้มคลองไม่ได้แจ้งเรยว่าต้องขาด2ข้อขึ้นไป   ทั้งที่มีใบรับรองความพิการ  มีให้ทุกอย่างครบ  คือเอาเปรียบมาก  นิ้วขาดก็ ทุคคลภาพโดยสิ้นเชิงแล้วเพราะต่อไม่ได้  และในความคุ้มคลองของประกันที่แจ้งมานี้ไม่เคยระบุนิ้วบอกเรย  หน้ากรรมฑัณที่ไปค้นหามาก็ไม่ได้ระบุเรยว่าต้อง2ข้อ  และมาระบุที่หลังในใบที่แจ้งมา  ว่าต้อง2ข้อ  และก็ไม่ม่นิ้วก้อยในกรรมฑัณ  เอาเปรียบผุ้บริโภคมาก  ',
      Company_Name: 'บริษัท วิริยะประกันภัย จำกัด (มหาชน) / The Viriyah Insurance Public company Limited.',
      Send_Date: '2021-02-22T09:20:52',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/02173',
      Complain_Date: '2021-02-03T00:00:00',
      Complain_Time: '13:22',
      CusIden: '1620400165514',
      Cusname: 'วัชรากรณ์ โทรักษา',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ไม่ได้รับความเป็นธรรม กับบริษัทประกันภัยวิริยะกับค่าสินไหม',
      Complain_Details: 'ทำประกันอุบัติเหตุกับวิริยะไว้    ปีละ400  พอเกิดอุบัติเหตุ  นิ้วก้อยขาด1ข้อ  ยืนเรื่องเอาประกันตัวที่ทำไว้  แต่มีผลกลับมาว่าจ่ายไม่ได้ไม่เข้ากับความคุ้มคลอง  ทั้งที่ในรายระเอียดคุ้มคลองไม่ได้แจ้งเรยว่าต้องขาด2ข้อขึ้นไป   ทั้งที่มีใบรับรองความพิการ  มีให้ทุกอย่างครบ  คือเอาเปรียบมาก  นิ้วขาดก็ ทุคคลภาพโดยสิ้นเชิงแล้วเพราะต่อไม่ได้  และในความคุ้มคลองของประกันที่แจ้งมานี้ไม่เคยระบุนิ้วบอกเรย  หน้ากรรมฑัณที่ไปค้นหามาก็ไม่ได้ระบุเรยว่าต้อง2ข้อ  และมาระบุที่หลังในใบที่แจ้งมา  ว่าต้อง2ข้อ  และก็ไม่ม่นิ้วก้อยในกรรมฑัณ  เอาเปรียบผุ้บริโภคมาก  ',
      Company_Name: 'บริษัท วิริยะประกันภัย จำกัด (มหาชน) / The Viriyah Insurance Public company Limited.',
      Send_Date: '2021-02-22T09:21:18',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/02174',
      Complain_Date: '2021-02-03T00:00:00',
      Complain_Time: '13:23',
      CusIden: '1620400165514',
      Cusname: 'วัชรากรณ์ โทรักษา',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ไม่ได้รับความเป็นธรรม กับบริษัทประกันภัยวิริยะกับค่าสินไหม',
      Complain_Details: 'ทำประกันอุบัติเหตุกับวิริยะไว้    ปีละ400  พอเกิดอุบัติเหตุ  นิ้วก้อยขาด1ข้อ  ยืนเรื่องเอาประกันตัวที่ทำไว้  แต่มีผลกลับมาว่าจ่ายไม่ได้ไม่เข้ากับความคุ้มคลอง  ทั้งที่ในรายระเอียดคุ้มคลองไม่ได้แจ้งเรยว่าต้องขาด2ข้อขึ้นไป   ทั้งที่มีใบรับรองความพิการ  มีให้ทุกอย่างครบ  คือเอาเปรียบมาก  นิ้วขาดก็ ทุคคลภาพโดยสิ้นเชิงแล้วเพราะต่อไม่ได้  และในความคุ้มคลองของประกันที่แจ้งมานี้ไม่เคยระบุนิ้วบอกเรย  หน้ากรรมฑัณที่ไปค้นหามาก็ไม่ได้ระบุเรยว่าต้อง2ข้อ  และมาระบุที่หลังในใบที่แจ้งมา  ว่าต้อง2ข้อ  และก็ไม่ม่นิ้วก้อยในกรรมฑัณ  เอาเปรียบผุ้บริโภคมาก  ',
      Company_Name: 'บริษัท วิริยะประกันภัย จำกัด (มหาชน) / The Viriyah Insurance Public company Limited.',
      Send_Date: '2021-02-22T09:21:51',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/02176',
      Complain_Date: '2021-02-03T00:00:00',
      Complain_Time: '13:24',
      CusIden: '1620400165514',
      Cusname: 'วัชรากรณ์ โทรักษา',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ไม่ได้รับความเป็นธรรม กับบริษัทประกันภัยวิริยะกับค่าสินไหม',
      Complain_Details: 'ทำประกันอุบัติเหตุกับวิริยะไว้    ปีละ400  พอเกิดอุบัติเหตุ  นิ้วก้อยขาด1ข้อ  ยืนเรื่องเอาประกันตัวที่ทำไว้  แต่มีผลกลับมาว่าจ่ายไม่ได้ไม่เข้ากับความคุ้มคลอง  ทั้งที่ในรายระเอียดคุ้มคลองไม่ได้แจ้งเรยว่าต้องขาด2ข้อขึ้นไป   ทั้งที่มีใบรับรองความพิการ  มีให้ทุกอย่างครบ  คือเอาเปรียบมาก  นิ้วขาดก็ ทุคคลภาพโดยสิ้นเชิงแล้วเพราะต่อไม่ได้  และในความคุ้มคลองของประกันที่แจ้งมานี้ไม่เคยระบุนิ้วบอกเรย  หน้ากรรมฑัณที่ไปค้นหามาก็ไม่ได้ระบุเรยว่าต้อง2ข้อ  และมาระบุที่หลังในใบที่แจ้งมา  ว่าต้อง2ข้อ  และก็ไม่ม่นิ้วก้อยในกรรมฑัณ  เอาเปรียบผุ้บริโภคมาก  ',
      Company_Name: 'บริษัท วิริยะประกันภัย จำกัด (มหาชน) / The Viriyah Insurance Public company Limited.',
      Send_Date: '2021-02-22T09:22:29',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/02129',
      Complain_Date: '2021-02-02T00:00:00',
      Complain_Time: '16:22',
      CusIden: '3100501516992',
      Cusname: 'หนึ่งฤทัย ทัพเทพ ',
      attorneyIden: '3100501516992',
      attorneyname: 'หนึ่งฤทัย ทัพเทพ ',
      Complain_Subject: 'ไม่ได้รับการปกป้องความเสี่ยงจากบริษัทเอไอเอ จำกัด',
      Complain_Details: 'ข้าพเจ้าซื้อกรมธรรม์เลขที่ T191272051 กับบริษัท เอไอเอ จำกัด โดยวันที่เริ่มสัญญาคือ วันที่ 26 ธันวาคม 2557 กับตัวแทนประกันชีวิตของบริษัท เอไอเอ ชื่อ นายประยุรพงศ์ พิศนาคะ โดยต้องจ่ายค่าเบี้ยประกัน 27,866บาทเป็นรายปี แต่ในวันที่ 26 ธันวาคม 2562 นายประยุรพงศ์ พิศนาคะ ยังมาเก็บเบี้ยประกันด้วยเงินสดจากข้าพเจ้า โดยที่ไม่ไปชำระให้บริษัท เอไอเอ โดยที่ข้าพเจ้าไม่ทราบว่านายประยุรพงศ์ พิศนาคะไม่ได้เป็นตัวแทนประกันชีวิตของบริษัท เอไอเอ ไปแล้ว ตั้งแต่วันที่ 1 เมษายน 2562 เนื่องจากทางบริษัทเอไอเอ ไม่ได้มีเอกสารแจ้งเรื่องนี้ถึงข้าพเจ้ามาก่อน ทำให้เกิดเรื่องฉ้อโกงโดยตัวแทนประกันชีวิตของบริษัทเอไอเอเช่นนี้ ความเสียหายที่เกิดขึ้น รวมถึงค่าเบี้ยประกันของบุคคลในครอบครัวของข้าพเจ้าที่ได้ร่วมซื้อประกันชีวิตจากบริษัทเอไอเอ กับตัวแทนประกันท่านนี้ นอกจากจะเสียทรัพย์เป็นเงินสดแล้ว ทางบริษัทเอไอเอ ยังจะตัดสิทธิ์ในการเอาประกันด้วย ซึ่งเป็นการไม่ยุติธรรมต่อผู้ซื้อบริการกับทางบริษัท รวมถึงยังคิดดอกเบี้ยจากการที่ข้าพเจ้าไม่ได้่จ่ายเงินค่าเบี้ยตามสัญญา ซึ่งไม่เป็นความจริง เพราะได้มีการชำระเงินผ่านตัวแทนประกันชีวิตของบริษํัทเอไอเอไปแล้ว ทำให้ข้าพเจ้าต้องหาเงินมาชำระค่าเบี้ยประกันเพิ่ม และยังต้องติดต่อดำเนินคดีนายประยุรพงศ์ พิศนาคะด้วยตัวเองโดยที่บริษัท เอไอเอ ไม่รับผิดชอบสิ่งใดเลย หากบริษัทเอไอเอ ได้มีการแจ้งมายังข้าพเจ้าก่อนว่าตัวแทนประกันชีวิตของบริษัท เอไอเอ ผู้นี้ไม่ได้เป็นตัวแทนประกันชีวิตของบริษัทเอไอเอแล้ว ข้าพเจ้าก็คงไม่ต้องสูญเสียทรัพย์สิน เวลาในการติดตามและความรู้สึกกังวลใจเช่นนี้ จึงอยากให้ สคบ พิจารณารับเรื่องร้องทุกข์นี้และดำเนินการตามกฏหมายกับบริษัท เอไอเอ จำกัดด้วยค่ะ',
      Company_Name: 'บริษัท อเมริกันอินเตอร์แนชชั่นแนลแอสชัวรันส์ จำกัด (AIA) / American International Assurance Co.,Ltd. (Thailand)',
      Send_Date: '2021-02-22T09:28:10',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/02429',
      Complain_Date: '2021-02-07T00:00:00',
      Complain_Time: '13:03',
      CusIden: '1471600011581',
      Cusname: 'ศิริลักษณ์ โคตรสุโน',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ขอความเป็นธรรมกรณีผู้ประกอบการไม่รับผิดชอบ',
      Complain_Details: '                                                                       5  กุมภาพันธ์  2564 \r\n\r\nเรื่อง\tขอความเป็นธรรมกรณีผู้ประกอบการไม่รับผิดชอบ\r\nเรียน\tคณะกรรมการคุ้มครองผู้บริโภค (สคบ)  \r\nสิ่งที่ส่งมาด้วย   ๑.   สำเนากรมธรรม์บริษัทไทวิวัฒน์                                                            ๒   แผ่น      \r\n                       ๒.    สำเนาบันทึกวันเกิดเหตุ ภาพถ่ายอุบัติเหตุและความเสียหายจากอุบัติ    ๒   แผ่น      \r\n                       ๓.    สำเนาหนังสือแจ้งความลงบันทำประจำวัน                                           ๒   แผ่น      \r\n                         ๔.    สำเนาหนังสือปฏิเสธความรับผิดชอบ                                                   ๒   แผ่น                 \r\n                        ด้วยข้าพเจ้านางสาวศิริลักษร์    โคตรสุโน   ได้ทำประกันรถยนต์ไว้กับบริษัทไทวิวัฒน์ \r\n( รายละเอียดปรากฏตามสิ่งที่ส่งมาด้วย ข้อ.1  ) \r\n         ต่อมาเมื่อวันที่  ๑๐ เดือน ธันวาคม  2563  เวลา ๑๘.๐๐  น. ข้าพเจ้าได้ใช้รถด้วยความระมัดระวังตามวิญญูชนพึ่งกระทำ  แต่อุบัติเหตุเกิดขึ้นได้ตลอดเวลา  ข้าพเจ้าได้ขับรถประสบอุบัติเหตุชนเบียดเข้ากับเสาบ้านทำให้รถเกิดความเสียหาย  ยางล้อด้านขาวฉีกขาด ล้อแม๊กด้านขวาขาด แหร็กพวงมาลัยได้รับความเสียหายจากการกระแทกไม่สามารถใช้งานได้เหมือนปกติ (รายละเอียดปรากฏตามรายละเอียดที่ส่งมาด้วย    ข้อ. ๒ , ข้อ ๓  )  \r\n       เมื่อนับแต่วันที่เกิดอุบัติเหตุเบื้องต้น  ข้าพเจ้าได้โทรไปแจ้งบริษัทฯ ตามระเบียบ บริษัทฯแจ้งให้ข้าพเจ้านำรถเข้าตรวจสภาพและซ่อมที่อู่ ว.ช่างยนต์ อยู่ที่อำเภอสว่างแดนดิน  จังหวัดสกลนคร ที่เป็นอู่รับซ่อมในเครือบรษัท ฯ   ตามที่บริษัทฯแจ้งให้ทราบ   บริษัทฯได้ปฏิเสธการซ่อมทั้งหมดที่เกิดความเสียจากอุบัติเหตุ  บริษัทฯ รับซ่อมบางกรณี (รายละเอียดปรากฏตามที่ส่งมาด้วย  ข้อ .4)  \r\n     ซึ่งผิดเงื่อนไขตามสิ่งที่ส่งมาด้วย ข้อ .1  ที่ระบุไว้ว่า รถยนต์เสียหาย ฯ  ความเสียหายต่อรถยนต์  ๑๐๐,๐๐๐  บาท  ต่อครั้ง การที่บริษัทฯ ปฏิเสธการรับผิดชอบข้าพเจ้าซึ่งเป็นผู้บริโภค จึงไม่ได้รับความเป็นธรรมจากผู้ประกอบการ  เป็นการถูกเอารัดเอาเปรียบจากกรณีดังกล่าว\t\t\r\n\t\tดังนั้น   ข้าพเจ้าจึงขอความเป็นธรรมมายังท่านได้โปรดตรวจสอบ  และดำเนินการคืนความเป็นธรรมให้กับข้าพเจ้าด้วย  \r\n                         อนึ่ง  รถยนต์ของข้าพเจ้าก็จอดไว้ที่อู่เป็นระยะเวลา 2 เดือนกว่าแล้ว  ยังไม่ได้รับการซ่อมให้แต่อย่างใด  ขอให้ท่านคิดค่าขาดประโยชน์ หรือ ค่าตอบแทน ในการที่ไม่ได้ใช้รถยนต์ ให้กับค่าข้าพเจ้าด้วย\r\n                                                            ขอแสดงความนับถือ\r\n\r\n                                             (ลงชื่อ)              ศิริลักษณ์  โคตรสุโน             ผู้ร้องทุกข์\r\n                                                                (นางสาวศิริลักษณ์  โคตรสุโน  )          \r\n\r\n\r\n                      ข้าพเจ้าขอรับรองว่า  ภาพถ่ายดังกล่าวเป็นภาพถ่ายบริเวณที่เกิดอุบัติเหตุเชี่ยวชนเสาบ้าน ทำให้รถยนต์ของข้าพเจ้าได้รับความเสียหาย   จริง\r\n\r\n                           \r\n                                                    (ลงชื่อ)            ศิริลักษณ์   โคตรสุโน                                                  \r\n                                                                   (นางสาวศิริลักษณ์  โคตรสุโน  )          \r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n                                            (ลงชื่อ)            ศิริลักษณ์   โคตรสุโน                                                  \r\n                                                                      (นางสาวศิริลักษณ์  โคตรสุโน  )          \r\n   \r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n                                                       (ลงชื่อ)          ศิริลักษณ์   โคตรสุโน                                                  \r\n                                                                      (นางสาวศิริลักษณ์  โคตรสุโน  )          \r\n   \r\n\r\n\r\n\r\n \r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n \r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n',
      Company_Name: 'บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน) / Thaivivat Insurance Public Company Limited',
      Send_Date: '2021-02-22T09:30:08',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/02401',
      Complain_Date: '2021-02-06T00:00:00',
      Complain_Time: '15:03',
      CusIden: '1100701540246',
      Cusname: 'พรปวีณ์ ดาปณีย์โชติกุล',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'โดนหลอกให้ซื้อประกันกรมธรรม์ใหม่',
      Complain_Details: 'ดิฉันได้ทำประกันกับบริษัทเจอเนอราลี่ไทยแลนด์ไว้ 2 กรมธรรม์ในตอนแรก มีประกันสะสมทรพย์ กรมธรรม์เลขที่ 01392204 และประกันสุขภาพและอุบัติเหตุ กรมธรรม์เลขที่ PP355007  ต่อมาข้าพเจ้าตัดสินใจยกเลิกประกันสะสมทรพย์กรมธรรม์เลขที่ 01392204 โดยข้าพเจ้ายุติการส่งเงิน ต่อมามีเจ้าหน้าที่ฝ่ายขายชื่อเสาวลักษณ์ ได้ติดต่อข้าพเจ้ามาแจ้งข้าพเจ้าว่ากรมธรรม์ของข้าพเจ้าหมดอายุแล้ว ควรทำเล่มใหม่เพื่อให้ได้รับความคุ้มครองอย่างต่อเนื่อง ข้าพเจ้าจึงได้ตัดสินใจทำกรมธรรม์เล่มใหม่ ข้าพเจ้าก็ได้จ่ายเงินให้กรมธรรม์เล่มนี้อยู่เกือบ 1 ปีเต็ม จนข้าพเจ้าได้เข้ารับการรักษาตัวด้วยโรคกระเพาะอักเสบที่โรงพยาบาลสมิตเวชศรีนครินทร์ในวันที่ 4 ตุลาคม 2563 และตอนออกจากโรงพยาบาลได้ทำการเบิกประกันข้าพเจ้าจึงได้ทราบว่าข้าพเจ้ามีประกันสุขภาพที่ทับซ้อนกันโดยให้ความคุ้มครองที่เหมือนกันอยู่ถึง 2 กรมธรรม์ และหลังจากที่ข้าพเจ้าออกจากโรงพยาบาลข้าพเจ้าจึงได้โทรไปที่ฝ่ายขายของบริษัทเจนเนอราลี่ด้วยตนเอง เพื่อคำอธิบายในเรื่องนี้ เผื่อว่าอาจจะเกิดความเข้าใจผิด แต่เจ้าหน้าที่ฝ่ายขายได้ให้คำอธิบายว่า ตัวกรมธรรม์เล่มที่หมดอายุมีอยู่จริงเลยชักชวนให้ทำเล่มใหม่ แต่ข้าพเจ้าคิดว่านั่นไม่น่าจะเป็นเหตุผลที่ดีได้ ข้าพเจ้าจึงขอเหตุผลและความรับผิดชอบที่ดีกว่านั้นโดยติดต่อไปทางฝ่ายขายของบริษัทเจนเนอราลี่อีกสามครั้ง แต่ก็ยังไม่มีใครติดต่อกลับมา ข้าพเจ้าในฐานะผู้บริโภคจึงมาร้องทุกข์กับทางสคบให้ช่วยเหลือข้าพเจ้าด้วยค่ะ',
      Company_Name: 'บริษัท เจนเนอราลี่ ประกันชีวิต (ไทยแลนด์) จำกัด (มหาชน) / Generali Life Assurance (Thailand) Public Company Limited',
      Send_Date: '2021-02-22T09:31:48',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/03219',
      Complain_Date: '2021-02-19T00:00:00',
      Complain_Time: '11:59',
      CusIden: '3349900175915',
      Cusname: 'พนิดา วัฒนจงกล',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ก่อสร้างไม่แล้วเสร็จตามสัญญา ',
      Complain_Details: ' เมื่อวันที่ 30 พฤศจิกายน 2560 นาง พนิดา วัฒนจงกล  ( ผู้ร้องทุกข์ ) ได้ทำสัญญาจะซื้อจะขายห้องชุด โครงการ วินด์แฮม แอทลาส วงศ์อมาตย์ พัทยา กับบริษัท ฮาบิแทท ทู จำกัด ห้องชุดเลขที่ 822 ชั้น 8 แบบ c2 เนื้อที่ 28.25 ตารางเมตร จำนวน 1 ห้อง เป็นจำนวนเงิน 4,738,900 บาท โดยได้ทำการชำระเงินจองเป็นจำนวนเงิน 50,000 บาท และเงินทำสัญญาเป็นจำนวน 424,000 บาท และได้ชำระเงินดาวน์ไปแล้วทั้งสิ้นเป็นจำนวน 24 งวด รวมเป็นจำนวนเงิน 480,000 บาท  รวมเป็นจำนวนเงินทั้งสิ้น 954,000 บาท ต่อมาทางบริษัทฯได้มีหนังสือแจ้งให้ผู้ร้องว่าสามารถโอนห้องชุดได้ประมาณไตรมาส2ปี 2564 ซึ่งสภาพความเป็นจริงแล้วโครงการก่อสร้างไม่แล้วเสร็จตามสัญญา(กำหนดแล้วเสร็จ 30 กันยายน 2563 ) ทำให้ผู้ร้องได้รับความเสียหายจากการไม่ได้รับโอนห้องชุดตามกำหนดผู้ร้องจึงได้ส่งหนังสือไปยังบริษัทเพื่อขอยกเลิกสัญญาและขอเงินคืน แต่ทางบริษัทปฎิเสธในคำขอของผู้ร้อง  จึงมาร้องทุกข์ต่อ สคบ.เพื่อขอยกเลิกสัญญาขอเงินที่ชำระไปแล้วคืนจากบริษัทฯ เป็นจำนวนเงินทั้งสิ้น 954,000 บาท พร้อมดอกเบี้ยตามกฎหมาย (รายละเอียดปรากฏตามบันทึกคำร้องทุกข์ลงวันที่ 19 กุมภาพันธ์ 2564 จำนวน 2 แผ่น)\r\nเอกสารหลักฐานประกอบคำร้องทุกข์ มีดังนี้ \r\n1.สำเนาบัตรประจำตัวประชาชน จำนวน 1 แผ่น \r\n2.สำเนา สัญญาจะซื้อจะขายห้องชุด จำนวน 1 ชุด \r\n3.สำเนาใบเสร็จรับเงินจำนวน 1 ชุด  \r\n 4.สำเนาเอกสารอื่นที่เกี่ยวข้อง จำนวน 1 ชุด ',
      Company_Name: 'บริษัท ฮาบิแทท ทูจำกัด',
      Send_Date: '2021-02-22T09:49:22',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/35131',
      Complain_Date: '2021-03-26T00:00:00',
      Complain_Time: '15:51',
      CusIden: '3440900609100',
      Cusname: 'ประมูล จันทศรี',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ร้องทุกข์ขอความเป็นธรรม นางวรรณศิริ เอี่ยมไกรอมร',
      Complain_Details: 'ผู้ร้องได้ซื้อประกันภัย กับทางบริษัท อเมริกันอินเตอร์แนชชั่นแนลแอสชัวรันส์ จำกัด (AIA) ตกลงทำสัญญาแบ่งการคุ้มครอง เป็น 3 ประเภท 1.ประกันชีวิตตลอดชีพ 2.คุ้มครองการยกเว้นเบี้ยประกันกรมธรรม์หลักและ 3. คุ้มครองโรคร้ายแรง และข้อร้องเรียนให้ความเป็นธรรมกับนางวรรณศิริฯ ผู้เอาประกัน โดยมีคำสั่งให้บริษัท อเมริกันอินเตอร์แนชชั่นแนลแอสชัวรันส์ จำกัด (AIA)ให้ถือเอากรมธรรมืประกันหมายเลขที่ T079944155 ลงวันที่ 13 มิ.ย. 2540 มีผลผูกพันตามข้อความสัญญากรมธรรม์"...แบบการประกัยภัย ตลอดชีพ ชำระเบี้ยประกันภัย 20 ปี 13 มิ.ย. 2540 วันที่ทำสัญญาประกันภัย..." และบริษัทมีหน้าที่จ่ายเงินเอาประกัน จำนวน 500,000 บาทให้กับทายาทวรรณศิริฯ กรณีเสียชีวิต รายละเอียดตามเอกสารแนบ',
      Company_Name: 'บริษัท อเมริกันอินเตอร์แนชชั่นแนลแอสชัวรันส์ จำกัด (AIA) / American International Assurance Co.,Ltd. (Thailand)',
      Send_Date: '2021-03-26T15:52:58',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/35130',
      Complain_Date: '2021-03-26T00:00:00',
      Complain_Time: '15:49',
      CusIden: '1471600011581',
      Cusname: 'ศิริลักษณ์ โคตรสุโน',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ขอความเป็นธรรมกรณีผู้ประกอบการไม่รับผิดชอบ',
      Complain_Details: '5กุมภาพันธ์2564\r\n\r\nเรื่อง\tขอความเป็นธรรมกรณีผู้ประกอบการไม่รับผิดชอบ\r\nเรียน\tคณะกรรมการคุ้มครองผู้บริโภค(สคบ)\r\nสิ่งที่ส่งมาด้วย๑.สำเนากรมธรรม์บริษัทไทวิวัฒน์๒แผ่น\r\n๒.สำเนาบันทึกวันเกิดเหตุภาพถ่ายอุบัติเหตุและความเสียหายจากอุบัติ๒แผ่น\r\n๓.สำเนาหนังสือแจ้งความลงบันทำประจำวัน๒แผ่น\r\n๔.สำเนาหนังสือปฏิเสธความรับผิดชอบ๒แผ่น\r\nด้วยข้าพเจ้านางสาวศิริลักษร์โคตรสุโนได้ทำประกันรถยนต์ไว้กับบริษัทไทวิวัฒน์\r\n(รายละเอียดปรากฏตามสิ่งที่ส่งมาด้วยข้อ.1)\r\nต่อมาเมื่อวันที่๑๐เดือนธันวาคม2563เวลา๑๘.๐๐น.ข้าพเจ้าได้ใช้รถด้วยความระมัดระวังตามวิญญูชนพึ่งกระทำแต่อุบัติเหตุเกิดขึ้นได้ตลอดเวลาข้าพเจ้าได้ขับรถประสบอุบัติเหตุชนเบียดเข้ากับเสาบ้านทำให้รถเกิดความเสียหายยางล้อด้านขาวฉีกขาดล้อแม๊กด้านขวาขาดแหร็กพวงมาลัยได้รับความเสียหายจากการกระแทกไม่สามารถใช้งานได้เหมือนปกติ(รายละเอียดปรากฏตามรายละเอียดที่ส่งมาด้วยข้อ.๒,ข้อ๓)\r\nเมื่อนับแต่วันที่เกิดอุบัติเหตุเบื้องต้นข้าพเจ้าได้โทรไปแจ้งบริษัทฯตามระเบียบบริษัทฯแจ้งให้ข้าพเจ้านำรถเข้าตรวจสภาพและซ่อมที่อู่ว.ช่างยนต์อยู่ที่อำเภอสว่างแดนดินจังหวัดสกลนครที่เป็นอู่รับซ่อมในเครือบรษัทฯตามที่บริษัทฯแจ้งให้ทราบบริษัทฯได้ปฏิเสธการซ่อมทั้งหมดที่เกิดความเสียจากอุบัติเหตุบริษัทฯรับซ่อมบางกรณี(รายละเอียดปรากฏตามที่ส่งมาด้วยข้อ.4)\r\nซึ่งผิดเงื่อนไขตามสิ่งที่ส่งมาด้วยข้อ.1ที่ระบุไว้ว่ารถยนต์เสียหายฯความเสียหายต่อรถยนต์๑๐๐,๐๐๐บาทต่อครั้งการที่บริษัทฯปฏิเสธการรับผิดชอบข้าพเจ้าซึ่งเป็นผู้บริโภคจึงไม่ได้รับความเป็นธรรมจากผู้ประกอบการเป็นการถูกเอารัดเอาเปรียบจากกรณีดังกล่าว\t\t\r\n\t\tดังนั้นข้าพเจ้าจึงขอความเป็นธรรมมายังท่านได้โปรดตรวจสอบและดำเนินการคืนความเป็นธรรมให้กับข้าพเจ้าด้วย\r\nอนึ่งรถยนต์ของข้าพเจ้าก็จอดไว้ที่อู่เป็นระยะเวลา2เดือนกว่าแล้วยังไม่ได้รับการซ่อมให้แต่อย่างใดขอให้ท่านคิดค่าขาดประโยชน์หรือค่าตอบแทนในการที่ไม่ได้ใช้รถยนต์ให้กับค่าข้าพเจ้าด้วย\r\nขอแสดงความนับถือ\r\n\r\n(ลงชื่อ)ศิริลักษณ์โคตรสุโนผู้ร้องทุกข์\r\n(นางสาวศิริลักษณ์โคตรสุโน)\r\n\r\nข้าพเจ้าขอรับรองว่าภาพถ่ายดังกล่าวเป็นภาพถ่ายบริเวณที่เกิดอุบัติเหตุเชี่ยวชนเสาบ้านทำให้รถยนต์ของข้าพเจ้าได้รับความเสียหายจริง\r\n\r\n(ลงชื่อ)ศิริลักษณ์โคตรสุโน\r\n(นางสาวศิริลักษณ์โคตรสุโน)\r\n\r\n(ลงชื่อ)ศิริลักษณ์โคตรสุโน\r\n(นางสาวศิริลักษณ์โคตรสุโน)\r\n\r\n(ลงชื่อ)ศิริลักษณ์โคตรสุโน\r\n(นางสาวศิริลักษณ์โคตรสุโน)',
      Company_Name: 'บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน) / Thaivivat Insurance Public Company Limited',
      Send_Date: '2021-03-26T15:53:05',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/35129',
      Complain_Date: '2021-03-26T00:00:00',
      Complain_Time: '15:43',
      CusIden: '1100701540246',
      Cusname: 'พรปวีณ์ ดาปณีย์โชติกุล',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'โดนหลอกให้ซื้อประกันกรมธรรม์ใหม่',
      Complain_Details: 'ดิฉันได้ทำประกันกับบริษัทเจอเนอราลี่ไทยแลนด์ไว้ 2 กรมธรรม์ในตอนแรก มีประกันสะสมทรพย์ กรมธรรม์เลขที่ 01392204 และประกันสุขภาพและอุบัติเหตุ กรมธรรม์เลขที่ PP355007  ต่อมาข้าพเจ้าตัดสินใจยกเลิกประกันสะสมทรพย์กรมธรรม์เลขที่ 01392204 โดยข้าพเจ้ายุติการส่งเงิน ต่อมามีเจ้าหน้าที่ฝ่ายขายชื่อเสาวลักษณ์ ได้ติดต่อข้าพเจ้ามาแจ้งข้าพเจ้าว่ากรมธรรม์ของข้าพเจ้าหมดอายุแล้ว ควรทำเล่มใหม่เพื่อให้ได้รับความคุ้มครองอย่างต่อเนื่อง ข้าพเจ้าจึงได้ตัดสินใจทำกรมธรรม์เล่มใหม่ ข้าพเจ้าก็ได้จ่ายเงินให้กรมธรรม์เล่มนี้อยู่เกือบ 1 ปีเต็ม จนข้าพเจ้าได้เข้ารับการรักษาตัวด้วยโรคกระเพาะอักเสบที่โรงพยาบาลสมิตเวชศรีนครินทร์ในวันที่ 4 ตุลาคม 2563 และตอนออกจากโรงพยาบาลได้ทำการเบิกประกันข้าพเจ้าจึงได้ทราบว่าข้าพเจ้ามีประกันสุขภาพที่ทับซ้อนกันโดยให้ความคุ้มครองที่เหมือนกันอยู่ถึง 2 กรมธรรม์ และหลังจากที่ข้าพเจ้าออกจากโรงพยาบาลข้าพเจ้าจึงได้โทรไปที่ฝ่ายขายของบริษัทเจนเนอราลี่ด้วยตนเอง เพื่อคำอธิบายในเรื่องนี้ เผื่อว่าอาจจะเกิดความเข้าใจผิด แต่เจ้าหน้าที่ฝ่ายขายได้ให้คำอธิบายว่า ตัวกรมธรรม์เล่มที่หมดอายุมีอยู่จริงเลยชักชวนให้ทำเล่มใหม่ แต่ข้าพเจ้าคิดว่านั่นไม่น่าจะเป็นเหตุผลที่ดีได้ ข้าพเจ้าจึงขอเหตุผลและความรับผิดชอบที่ดีกว่านั้นโดยติดต่อไปทางฝ่ายขายของบริษัทเจนเนอราลี่อีกสามครั้ง แต่ก็ยังไม่มีใครติดต่อกลับมา ข้าพเจ้าในฐานะผู้บริโภคจึงมาร้องทุกข์กับทางสคบให้ช่วยเหลือข้าพเจ้าด้วยค่ะ',
      Company_Name: 'บริษัท เจนเนอราลี่ ประกันชีวิต (ไทยแลนด์) จำกัด (มหาชน) / Generali Life Assurance (Thailand) Public Company Limited',
      Send_Date: '2021-03-26T15:53:13',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/35128',
      Complain_Date: '2021-03-26T00:00:00',
      Complain_Time: '15:41',
      CusIden: '1620400165514',
      Cusname: 'วัชรากรณ์ โทรักษา',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'ไม่ได้รับความเป็นธรรม กับบริษัทประกันภัยวิริยะกับค่าสินไหม',
      Complain_Details: 'ทำประกันอุบัติเหตุกับวิริยะไว้    ปีละ400  พอเกิดอุบัติเหตุ  นิ้วก้อยขาด1ข้อ  ยืนเรื่องเอาประกันตัวที่ทำไว้  แต่มีผลกลับมาว่าจ่ายไม่ได้ไม่เข้ากับความคุ้มคลอง  ทั้งที่ในรายระเอียดคุ้มคลองไม่ได้แจ้งเรยว่าต้องขาด2ข้อขึ้นไป   ทั้งที่มีใบรับรองความพิการ  มีให้ทุกอย่างครบ  คือเอาเปรียบมาก  นิ้วขาดก็ ทุคคลภาพโดยสิ้นเชิงแล้วเพราะต่อไม่ได้  และในความคุ้มคลองของประกันที่แจ้งมานี้ไม่เคยระบุนิ้วบอกเรย  หน้ากรรมฑัณที่ไปค้นหามาก็ไม่ได้ระบุเรยว่าต้อง2ข้อ  และมาระบุที่หลังในใบที่แจ้งมา  ว่าต้อง2ข้อ  และก็ไม่ม่นิ้วก้อยในกรรมฑัณ  เอาเปรียบผุ้บริโภคมาก',
      Company_Name: 'บริษัท วิริยะประกันภัย จำกัด (มหาชน) / The Viriyah Insurance Public company Limited.',
      Send_Date: '2021-03-26T15:53:22',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
    {
      Complain_Code_ID: 'OCPB0164/35127',
      Complain_Date: '2021-03-26T00:00:00',
      Complain_Time: '15:40',
      CusIden: '3200100108574',
      Cusname: 'ฉิมพลี วิมลธรรม',
      attorneyIden: null,
      attorneyname: null,
      Complain_Subject: 'บริษัทโปกเกอร์ประกันภัยรถยนตร์รับเงินแล้วไม่ส่งกรมธรรม์',
      Complain_Details: 'ดิฉันซื้อรถยนต์ หมายเลขทะเบียนรถ 9 กน 6539 เมื่อเดือนพฤศจิกายน ปี 2562 โปรโมชั่นแถมการประกันภัยชั้น 1 ให้  หลังจากนั้นเมื่อเดือนมิถุนายน  2563 ดิฉันได้รับการติดต่อจากโบกเกอร์ประกันภัย (บริษัท C S T ประเทศไทย ) โดยอ้างว่าดูแลเรื่องประกันภัยคันนี้ โทรศัพท์มาหลายครั้งเพื่อให้ดิฉันต่อประกันกับบริษัทเดิมคือโตเกียวมารีน แต่ดิฉันก็ยังไม่ตกลงเพราะเห็นว่ายังมีเวลาอีกนานกว่าจะหมดระยะเวลาคุ้มครอง ทางโปกเกอร์ก็มีข้อเสนอให้เบี้ยประกันราคาพิเศษ สามารถผ่อนชำระผ่านบัตรเครดิตธนาคารกรุงไทย  ในราคา 17,900 บาท เวลา 6 งวด โดยไม่เสียดอกเบี้ย เมื่อตกลงทางบริษัทได้ให้พนักงานนำเครื่องรูดบัตรมาถึงบ้าน โดยมิได้มอบเอกสารใดๆ บอกว่าทางบริษัทจะจัดส่งภายหลัง  แต่พอชำระจริง 6 งวด ทางบริษัทได้ผลักดอกเบี้ยที่ต้องจ่าย เป็นเงิน 18,101.02 บาท เมื่อครบกำหนดกรมธรรม์หมดอายุ ได้โทรถามพนักงาน แต่ก็บอกว่ากำลังดำเนินการประกันกับบริษัทเมืองไทยประกันภัย จนเมื่อเดิอนธันวาคม มีอุบัติเหตุ ดิฉันได้โทรไปที่บริษัทเมืองไทย แจ้งว่ายังไม่มีข้อมูลการประกันรถของดิฉัน จึงโทรหาทางบริษัทแต่ก็ได้รับคำตอบเหมือนเดิมว่ากำหลังประสาร ครั้งแรกเมื่อเดือนปลายธันวาคมพนักงานชื่อพิมพ์ประภา ดิฉันขอร้องเค้าให้จัดการเรื่องพรบ. รถยนต์ก่อนไม่มีมันผิดกฏหมายเพราะกังวลมาก  ทางบริษัทจัดการให้ดำเนินการต่อทะเบียนให้ แต่ก็ไม่ติดต่อกลังมา โทรไม่รับสาย ไลน์ไปไม่ตอบ  และบอกให้รอประกันภัย  คนที่ 2 ดิฉันโทรเข้าทางบริษัทพนักงานชื่อณัชชา เมื่อวันที่ 15 มกราคม   รับปากว่าจะดำเนินการ แต่ก็เงียบหายโทรไปไม่รับ ไลน์ไม่ตอบเช่นเคย ดิฉันจึงโทรไปบริษัท  จนวันที่ 28 มกราคม คนที่ 3  ผู้รับสายคือเขมมิกกา รับเรื่อง แล้วเงียบไป  ดิฉันโทรไปตามได้รับคำตอบว่าจะคืนเงินให้ จนวันนี้ยังไม่ได้รับการประสานจากบริษัทนี้เลย ดิฉันเดือดร้อนมาก ในสภาวะแบบนี้เงินที่เสียไปก็มากพอสมควร แล้วถ้าต้องให้เสียใหม่ ตอนนี้ดิฉันขับรถอย่างไม่มั่นใจเลย \r\n    ขอความกรุณาช่วยตามเรื่องให้ด้วยค่ะ \r\nที่อยู่ของบริษัท ซีเอสที 2019 (ประเทศไทย) จำกัด\r\n59/223 ม.4 แขวงกระทุ่มราย เขตหนองจอก กรุงเทพ 10530 \r\nโทร 065 59487 และ 065 5915457',
      Company_Name: 'บริษัท ซีเอสที 2019 (ประเทศไทย) จำกัด',
      Send_Date: '2021-03-26T15:53:29',
      Remark: '',
      StatusTH: 'ส่งเรื่องต่อหน่วยงานภายนอก',
      IsCloseDate: null,
      RecieveDate: null,
    },
  ],
}

mock.onGet('/complaint/list').reply(() => [200, dataComplaint.Message])
